var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErzeugungsanlagenBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 420,
    viewBox: "0 0 457 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Erzeugungsanlagen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M236.964 419.216L0.372314 281.915L0.416748 263.423L36.4819 254.32L236.964 349.824L240.553 379.955L243.356 397.19L242.194 414.452L236.964 419.216Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M236.97 419.552L0.38208 282.956V280.417L236.97 417.159V419.552Z",
    fill: "#826955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M456.927 292.806L236.969 419.553L236.969 390.281L421.579 259.441L456.911 273.215L456.927 292.806Z",
    fill: "#3C3839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.38208 263.473L236.964 400.762L456.912 273.215L220.185 148.381L0.38208 263.473Z",
    fill: "#65813F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Baum"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M62.2664 253.257C47.5238 253.257 35.5729 258.764 35.5729 265.559C35.5729 272.354 47.5238 277.862 62.2664 277.862C77.0091 277.862 88.96 272.354 88.96 265.559C88.96 258.764 77.0091 253.257 62.2664 253.257Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M42.507 268.968L45.2665 247.345C45.2543 247.798 45.3843 248.243 45.6383 248.618C45.8923 248.993 46.2575 249.279 46.6825 249.436C47.7336 249.962 48.8908 250.242 50.0664 250.255C51.242 250.268 52.405 250.013 53.4675 249.51C53.8672 249.339 54.2114 249.06 54.4616 248.705C54.7118 248.349 54.8581 247.931 54.8841 247.497L57.8662 269.796C58.0156 271.063 57.2698 272.331 55.6293 273.3C53.9188 274.163 52.0294 274.613 50.1132 274.613C48.197 274.613 46.3075 274.163 44.597 273.3C42.5076 272.174 41.8362 270.456 42.507 268.968Z",
    fill: "#816955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M67.9326 208.722C57.1846 208.722 48.4723 217.802 48.4723 229.003C48.4723 240.204 57.1846 249.283 67.9326 249.283C78.68 249.283 87.3929 240.204 87.3929 229.003C87.3929 217.802 78.68 208.722 67.9326 208.722Z",
    fill: "#558835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M40.1964 205.143C30.6431 205.143 22.8986 213.221 22.8986 223.186C22.8986 233.152 30.6431 241.23 40.1964 241.23C49.7491 241.23 57.4943 233.152 57.4943 223.186C57.4943 213.221 49.7491 205.143 40.1964 205.143Z",
    fill: "#619640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M27.8925 230.791C34.6775 234.668 45.638 234.668 52.4237 230.791C55.854 228.778 57.5688 226.169 57.4944 223.559C57.9414 226.393 56.3016 230.121 52.4999 232.358C45.7156 236.235 34.7544 236.235 27.9695 232.358C26.5702 231.578 25.3789 230.473 24.4963 229.136C23.6136 227.8 23.0655 226.27 22.8981 224.677C23.27 226.915 24.9099 229.077 27.8925 230.791Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M54.9588 221.845C46.3524 221.845 39.3751 229.089 39.3751 238.025C39.3751 246.96 46.3524 254.203 54.9588 254.203C63.5651 254.203 70.5424 246.96 70.5424 238.025C70.5424 229.089 63.5651 221.845 54.9588 221.845Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M43.8501 244.884C49.9636 248.388 59.8069 248.388 65.9167 244.884C69.0526 243.094 70.5392 240.703 70.4648 238.397C70.8374 240.933 69.3458 244.288 65.9911 246.301C59.8776 249.805 50.0349 249.805 43.9245 246.301C42.6583 245.603 41.5819 244.607 40.7891 243.398C39.9964 242.189 39.5114 240.805 39.3763 239.366C39.6739 241.38 41.1694 243.319 43.8501 244.884Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M45.4156 234.967C48.3711 236.475 51.6415 237.26 54.9591 237.26C58.2767 237.26 61.5471 236.475 64.5026 234.967C65.4897 234.499 66.3578 233.812 67.0418 232.96C67.7257 232.108 68.2078 231.111 68.4519 230.046C68.7507 232.209 67.4065 234.446 64.5026 236.16C61.547 237.667 58.2767 238.453 54.9591 238.453C51.6416 238.453 48.3712 237.667 45.4156 236.16C42.5123 234.52 41.235 232.283 41.467 230.046C41.6883 231.836 43.0287 233.55 45.4156 234.967Z",
    fill: "#D9D9D0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M357.396 266.473C357.396 273.154 345.79 278.57 331.474 278.57C317.157 278.57 305.551 273.154 305.551 266.473C305.551 259.792 317.157 254.376 331.474 254.376C345.79 254.376 357.396 259.792 357.396 266.473Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "WindradOW"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Foot"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M327.718 259.034C324.087 259.034 320.457 259.834 317.686 261.433C314.916 263.033 313.531 265.128 313.531 267.224C313.531 269.321 314.916 271.416 317.686 273.016C320.457 274.614 324.087 275.416 327.718 275.416C331.348 275.416 334.979 274.614 337.749 273.016C340.52 271.416 341.905 269.321 341.905 267.224C341.905 265.128 340.52 263.033 337.749 261.433C334.978 259.834 331.348 259.033 327.718 259.034Z",
    fill: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M337.749 256.799C334.978 255.2 331.348 254.4 327.718 254.401C324.087 254.401 320.457 255.2 317.686 256.799C314.916 258.398 313.531 260.495 313.531 262.591V266.082C313.531 268.179 314.916 270.275 317.686 271.874C320.457 273.473 324.087 274.274 327.718 274.274C331.348 274.274 334.979 273.473 337.749 271.874C340.52 270.275 341.905 268.179 341.905 266.082V262.591C341.905 260.495 340.52 258.398 337.749 256.799Z",
    fill: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M327.988 254.406C324.358 254.286 320.704 254.965 317.882 256.472C315.061 257.979 313.608 260.028 313.538 262.123C313.469 264.219 314.784 266.359 317.5 268.05C320.217 269.738 323.818 270.659 327.447 270.778C331.075 270.898 334.731 270.217 337.552 268.712C340.374 267.204 341.828 265.156 341.896 263.06C341.966 260.965 340.651 258.824 337.935 257.134C335.218 255.444 331.616 254.524 327.988 254.406Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M326.162 133.096C327.234 133.715 328.971 133.715 330.042 133.096C330.578 132.787 330.844 132.381 330.844 131.977L333.572 262.587C333.572 263.397 333.038 264.203 331.97 264.819C329.834 266.054 326.371 266.054 324.234 264.819C323.167 264.203 322.633 263.397 322.633 262.587L325.359 131.977C325.359 132.381 325.627 132.787 326.162 133.096Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M326.162 133.096C327.234 133.715 328.971 133.715 330.042 133.096C330.578 132.787 330.844 132.381 330.844 131.977L333.572 262.587C333.572 263.397 333.038 264.203 331.97 264.819C329.834 266.054 326.371 266.054 324.234 264.819C323.167 264.203 322.633 263.397 322.633 262.587L325.359 131.977C325.359 132.381 325.627 132.787 326.162 133.096Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M325.363 131.977C325.363 132.381 325.631 132.787 326.165 133.096C327.237 133.715 328.974 133.715 330.046 133.096C330.582 132.787 330.847 132.381 330.847 131.977L330.961 138.362C329.184 139.149 326.689 140.208 325.211 140.634L325.363 131.977Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M317.798 120.268V120.262C317.798 120.262 325.082 117.206 329.601 116.695C331.294 116.502 332.551 116.676 333.455 117.043L341.131 119.98C341.136 119.981 341.14 119.984 341.143 119.985L341.291 120.041C341.292 120.044 341.294 120.046 341.295 120.049C342.391 120.522 342.986 121.823 342.8 123.174C342.596 124.674 341.496 127.369 339.445 128.985C338.592 129.656 336.743 131.228 335.876 131.883C333.803 133.449 326.873 137.081 326.873 137.081L317.257 131.531V121.188C317.257 120.684 317.472 120.362 317.798 120.268Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M318.594 120.416L325.534 124.423C326.269 124.847 326.873 125.89 326.873 126.74V137.081L317.257 131.53V121.189C317.257 120.338 317.858 119.991 318.594 120.416Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M338.251 120.948C339.553 120.457 340.526 120.131 341.365 120.09C341.363 120.089 341.367 120.082 341.367 120.081C342.416 120.579 342.979 121.856 342.798 123.175C342.593 124.675 341.493 127.369 339.442 128.985C338.589 129.656 336.74 131.229 335.873 131.884C333.8 133.449 326.87 137.082 326.87 137.082V127.151C328.533 126.183 336.292 121.688 338.251 120.948Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M318.774 123.563C317.463 124.904 317.872 128.072 319.69 130.636C321.509 133.199 324.046 134.191 325.357 132.849C326.669 131.508 326.258 128.341 324.442 125.776C322.623 123.213 320.085 122.222 318.774 123.563Z",
    fill: "#010203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M314.983 127.187L320.012 124.28C320.576 123.959 321.355 124.007 322.214 124.503C323.941 125.5 325.341 127.925 325.341 129.919C325.341 130.922 324.986 131.625 324.414 131.949L319.385 134.856C318.82 135.176 318.043 135.126 317.185 134.631C315.458 133.634 314.06 131.209 314.06 129.216C314.06 128.215 314.413 127.512 314.983 127.187Z",
    fill: "#64605E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rotor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FluegelOW2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "testCircleOW2",
    cx: 318.864,
    cy: 129.457,
    r: 71.5197,
    fill: "#FF0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M318.097 134.146L316.531 132.881L310.26 139.785L288.856 194.17L290.01 194.919L316.895 144.941L316.208 137.906L318.097 134.146Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M323.486 128.308L322.925 130.243L331.72 133.35L390.149 132.033L390.394 130.679L333.904 125.238L327.683 128.593L323.486 128.308Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M316.087 125.811L317.975 125.107L315.219 116.196L279.289 70.1006L278.056 70.7125L307.406 119.285L313.811 122.272L316.087 125.811Z",
    fill: "#DAD9D2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M316.274 121.645L316.331 121.621C318.161 120.779 320.946 122.144 323.022 125.071C325.411 128.443 325.95 132.608 324.225 134.372C324.045 134.558 323.841 134.701 323.629 134.82L323.632 134.826C323.617 134.832 323.605 134.836 323.593 134.842C323.419 134.934 323.237 135.009 323.044 135.059C313.057 138.992 307.05 135.718 307.05 135.718C308.329 125.471 315.597 121.952 316.274 121.645Z",
    fill: "#DAD9D2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "WindradOW_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Foot_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M243.028 250.72C239.397 250.72 235.767 251.52 232.996 253.119C230.226 254.718 228.84 256.814 228.84 258.91C228.84 261.007 230.226 263.102 232.996 264.702C235.767 266.3 239.397 267.102 243.028 267.102C246.658 267.102 250.289 266.3 253.059 264.702C255.83 263.102 257.215 261.007 257.215 258.91C257.215 256.814 255.83 254.718 253.059 253.119C250.288 251.52 246.658 250.719 243.028 250.72Z",
    fill: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M253.059 248.485C250.288 246.886 246.658 246.086 243.028 246.087C239.397 246.087 235.767 246.886 232.996 248.485C230.226 250.084 228.84 252.18 228.84 254.276V257.768C228.84 259.864 230.226 261.96 232.996 263.559C235.767 265.159 239.397 265.959 243.028 265.959C246.658 265.959 250.289 265.159 253.059 263.559C255.83 261.96 257.215 259.864 257.215 257.768V254.276C257.215 252.18 255.83 250.084 253.059 248.485Z",
    fill: "#B5B3AB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M243.298 246.091C239.668 245.972 236.014 246.651 233.192 248.158C230.371 249.664 228.917 251.714 228.848 253.808C228.779 255.904 230.094 258.044 232.81 259.735C235.526 261.424 239.128 262.344 242.757 262.464C246.385 262.584 250.041 261.903 252.862 260.397C255.684 258.889 257.138 256.841 257.206 254.745C257.276 252.651 255.961 250.509 253.245 248.819C250.528 247.13 246.926 246.21 243.298 246.091Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M241.472 124.782C242.544 125.401 244.281 125.401 245.352 124.782C245.888 124.473 246.154 124.067 246.154 123.663L248.882 254.273C248.882 255.082 248.348 255.889 247.28 256.505C245.144 257.739 241.681 257.739 239.544 256.505C238.477 255.889 237.943 255.082 237.943 254.273L240.669 123.663C240.669 124.067 240.937 124.473 241.472 124.782Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M241.472 124.782C242.544 125.401 244.281 125.401 245.352 124.782C245.888 124.473 246.154 124.067 246.154 123.663L248.882 254.273C248.882 255.082 248.348 255.889 247.28 256.505C245.144 257.739 241.681 257.739 239.544 256.505C238.477 255.889 237.943 255.082 237.943 254.273L240.669 123.663C240.669 124.067 240.937 124.473 241.472 124.782Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M240.673 123.663C240.673 124.067 240.941 124.473 241.475 124.782C242.547 125.401 244.284 125.401 245.356 124.782C245.892 124.473 246.157 124.067 246.157 123.663L246.271 130.048C244.494 130.835 241.999 131.893 240.521 132.32L240.673 123.663Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M233.108 111.954V111.948C233.108 111.948 240.392 108.892 244.911 108.38C246.604 108.188 247.861 108.362 248.765 108.729L256.441 111.666C256.445 111.667 256.45 111.669 256.453 111.671L256.601 111.727C256.602 111.73 256.604 111.732 256.605 111.735C257.701 112.208 258.296 113.509 258.11 114.86C257.906 116.36 256.806 119.055 254.755 120.671C253.902 121.342 252.053 122.914 251.186 123.569C249.113 125.134 242.183 128.767 242.183 128.767L232.567 123.217V112.874C232.567 112.37 232.782 112.048 233.108 111.954Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M233.904 112.102L240.844 116.109C241.579 116.533 242.183 117.576 242.183 118.425V128.767L232.567 123.216V112.874C232.567 112.024 233.168 111.677 233.904 112.102Z",
    fill: "#64605E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M253.561 112.634C254.863 112.143 255.836 111.817 256.675 111.776C256.673 111.775 256.677 111.768 256.677 111.767C257.726 112.265 258.289 113.542 258.108 114.861C257.902 116.361 256.803 119.055 254.752 120.671C253.899 121.342 252.05 122.915 251.183 123.57C249.109 125.135 242.179 128.768 242.179 128.768V118.836C243.842 117.869 251.602 113.373 253.561 112.634Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M234.084 115.249C232.773 116.59 233.182 119.757 235 122.322C236.819 124.885 239.356 125.877 240.667 124.535C241.979 123.194 241.568 120.027 239.752 117.462C237.933 114.899 235.395 113.908 234.084 115.249Z",
    fill: "#010203"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M230.292 118.873L235.322 115.965C235.886 115.644 236.665 115.693 237.523 116.188C239.251 117.185 240.65 119.611 240.65 121.604C240.65 122.608 240.296 123.311 239.724 123.635L234.695 126.542C234.13 126.861 233.353 126.812 232.495 126.316C230.768 125.32 229.37 122.895 229.37 120.901C229.37 119.9 229.723 119.198 230.292 118.873Z",
    fill: "#64605E"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rotor_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FluegelOW1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "testCircleOW1",
    cx: 234.174,
    cy: 121.142,
    r: 71.5197,
    fill: "#FF0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M233.407 125.832L231.841 124.567L225.57 131.471L204.166 185.855L205.319 186.605L232.205 136.626L231.518 129.591L233.407 125.832Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M238.796 119.993L238.235 121.928L247.03 125.036L305.459 123.719L305.704 122.364L249.214 116.923L242.993 120.279L238.796 119.993Z",
    fill: "#DAD9D2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M231.397 117.497L233.285 116.793L230.529 107.881L194.599 61.7864L193.366 62.3983L222.716 110.971L229.121 113.958L231.397 117.497Z",
    fill: "#DAD9D2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M231.584 113.331L231.64 113.307C233.471 112.464 236.256 113.83 238.332 116.757C240.721 120.129 241.26 124.293 239.535 126.057C239.355 126.243 239.151 126.387 238.939 126.506L238.942 126.512C238.927 126.517 238.915 126.522 238.903 126.528C238.729 126.62 238.547 126.695 238.354 126.745C228.367 130.678 222.36 127.404 222.36 127.404C223.639 117.156 230.907 113.638 231.584 113.331Z",
    fill: "#DAD9D2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "PVOverworld"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M196.033 262.048L178.498 263.928L140.462 242.217L187.667 212.31L234.965 239.507L196.033 262.048Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M168.601 248.946C168.601 251.495 164.871 253.562 160.272 253.562C155.672 253.562 151.944 251.495 151.944 248.946C151.944 246.396 155.672 244.33 160.272 244.33C164.871 244.33 168.601 246.396 168.601 248.946Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M168.594 248.797C168.597 248.847 168.601 248.897 168.601 248.946C168.601 251.495 164.872 253.562 160.273 253.562C155.673 253.562 151.944 251.495 151.944 248.946V251.215H151.95C152.076 253.704 155.752 255.7 160.273 255.7C164.872 255.7 168.601 253.634 168.601 251.084V248.797H168.594Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M173.254 177.001L211.657 199.309L176.076 258.437L136.5 235.498L173.254 177.001Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M173.777 178.822L209.703 199.889L174.394 255.714L138.457 234.506L173.777 178.822Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M203.355 207.067L197.543 203.677C196.962 203.337 196.153 202.212 197.004 201.027L200.108 196.134C200.448 195.618 201.507 195.431 202.089 195.77L208.251 199.337C208.832 199.676 209.119 200.321 208.93 200.957L205.486 206.385C204.942 207.151 203.937 207.406 203.355 207.067Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M194.342 201.836L188.53 198.446C187.948 198.106 187.14 196.981 187.991 195.797L191.095 190.904C191.435 190.388 192.494 190.2 193.075 190.54L199.239 194.106C199.82 194.445 200.106 195.09 199.917 195.726L196.473 201.155C195.929 201.921 194.924 202.176 194.342 201.836Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M198.187 214.901L192.374 211.51C191.793 211.171 190.985 210.046 191.835 208.861L194.939 203.968C195.279 203.452 196.339 203.265 196.92 203.604L203.083 207.17C203.665 207.509 203.951 208.155 203.762 208.79L200.318 214.219C199.774 214.985 198.769 215.24 198.187 214.901Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M189.14 209.7L183.327 206.31C182.745 205.97 181.938 204.845 182.789 203.66L185.893 198.768C186.233 198.252 187.292 198.065 187.873 198.404L194.036 201.97C194.617 202.309 194.904 202.954 194.714 203.59L191.27 209.019C190.727 209.785 189.721 210.04 189.14 209.7Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M185.335 196.578L179.523 193.188C178.942 192.848 178.133 191.723 178.984 190.539L182.088 185.645C182.428 185.13 183.487 184.942 184.069 185.282L190.231 188.848C190.812 189.187 191.099 189.832 190.91 190.468L187.466 195.897C186.922 196.663 185.917 196.917 185.335 196.578Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M176.321 191.348L170.508 187.957C169.927 187.618 169.119 186.493 169.97 185.308L173.074 180.415C173.414 179.9 174.473 179.712 175.054 180.051L181.218 183.618C181.799 183.957 182.085 184.602 181.896 185.238L178.452 190.667C177.908 191.433 176.903 191.687 176.321 191.348Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M180.163 204.411L174.35 201.021C173.768 200.681 172.961 199.556 173.811 198.371L176.915 193.478C177.255 192.963 178.315 192.775 178.896 193.114L185.059 196.681C185.64 197.02 185.926 197.665 185.736 198.301L182.293 203.73C181.75 204.496 180.744 204.75 180.163 204.411Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M171.117 199.212L165.305 195.822C164.724 195.482 163.915 194.357 164.766 193.172L167.87 188.279C168.21 187.763 169.269 187.576 169.851 187.915L176.013 191.482C176.594 191.821 176.881 192.467 176.692 193.102L173.248 198.53C172.704 199.296 171.699 199.551 171.117 199.212Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M193.159 222.853L187.346 219.463C186.765 219.123 185.956 217.998 186.807 216.814L189.911 211.921C190.251 211.405 191.311 211.217 191.892 211.557L198.055 215.123C198.636 215.462 198.922 216.108 198.732 216.743L195.288 222.172C194.745 222.938 193.74 223.193 193.159 222.853Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M184.142 217.622L178.329 214.231C177.747 213.892 176.94 212.767 177.79 211.582L180.894 206.689C181.234 206.173 182.294 205.986 182.875 206.325L189.037 209.892C189.618 210.231 189.905 210.876 189.715 211.512L186.272 216.94C185.729 217.706 184.723 217.961 184.142 217.622Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M188.126 230.856L182.313 227.466C181.732 227.126 180.924 226.001 181.774 224.816L184.878 219.923C185.218 219.408 186.278 219.22 186.859 219.559L193.021 223.126C193.603 223.465 193.889 224.11 193.7 224.746L190.256 230.175C189.713 230.941 188.708 231.195 188.126 230.856Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M179.051 225.695L173.238 222.304C172.657 221.965 171.849 220.84 172.699 219.655L175.803 214.762C176.143 214.246 177.203 214.059 177.784 214.398L183.947 217.964C184.528 218.303 184.815 218.948 184.626 219.584L181.182 225.013C180.638 225.779 179.633 226.034 179.051 225.695Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M175.137 212.364L169.324 208.973C168.743 208.634 167.935 207.509 168.786 206.324L171.89 201.431C172.229 200.915 173.289 200.728 173.87 201.067L180.033 204.634C180.615 204.973 180.901 205.618 180.712 206.254L177.268 211.682C176.724 212.448 175.719 212.703 175.137 212.364Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M166.121 207.133L160.308 203.742C159.727 203.403 158.919 202.278 159.769 201.092L162.873 196.2C163.213 195.684 164.273 195.497 164.854 195.836L171.016 199.402C171.598 199.741 171.884 200.386 171.695 201.022L168.251 206.451C167.708 207.217 166.703 207.472 166.121 207.133Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M169.967 220.34L164.154 216.949C163.572 216.61 162.764 215.485 163.615 214.299L166.719 209.407C167.059 208.891 168.119 208.704 168.7 209.043L174.863 212.61C175.444 212.949 175.73 213.594 175.54 214.23L172.096 219.658C171.553 220.424 170.548 220.679 169.967 220.34Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M160.914 215.149L155.101 211.758C154.52 211.419 153.712 210.294 154.563 209.109L157.667 204.216C158.007 203.7 159.066 203.513 159.647 203.852L165.81 207.419C166.391 207.758 166.678 208.403 166.489 209.039L163.045 214.467C162.501 215.234 161.495 215.488 160.914 215.149Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M183.217 238.815L177.404 235.424C176.822 235.085 176.015 233.96 176.865 232.775L179.969 227.882C180.309 227.366 181.369 227.179 181.95 227.518L188.113 231.084C188.695 231.423 188.981 232.068 188.791 232.704L185.347 238.133C184.804 238.899 183.798 239.154 183.217 238.815Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M174.206 233.584L168.393 230.193C167.811 229.854 167.004 228.729 167.854 227.544L170.958 222.651C171.298 222.136 172.358 221.948 172.939 222.288L179.102 225.854C179.683 226.193 179.969 226.838 179.779 227.474L176.336 232.903C175.792 233.669 174.787 233.923 174.206 233.584Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M178.048 246.648L172.236 243.257C171.654 242.918 170.846 241.793 171.697 240.608L174.801 235.715C175.141 235.199 176.2 235.012 176.781 235.351L182.945 238.918C183.526 239.257 183.812 239.902 183.623 240.538L180.179 245.967C179.635 246.733 178.63 246.987 178.048 246.648Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M169.003 241.448L163.191 238.058C162.609 237.718 161.801 236.593 162.652 235.408L165.756 230.515C166.096 229.999 167.155 229.812 167.736 230.151L173.899 233.718C174.48 234.057 174.767 234.702 174.578 235.338L171.133 240.767C170.59 241.533 169.584 241.787 169.003 241.448Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M165.195 228.326L159.383 224.935C158.802 224.596 157.993 223.471 158.844 222.285L161.948 217.393C162.288 216.877 163.347 216.69 163.929 217.029L170.091 220.596C170.672 220.935 170.959 221.58 170.77 222.216L167.326 227.644C166.782 228.411 165.777 228.665 165.195 228.326Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M156.183 223.094L150.37 219.704C149.789 219.364 148.981 218.239 149.831 217.055L152.935 212.161C153.275 211.646 154.335 211.458 154.916 211.798L161.079 215.365C161.661 215.704 161.947 216.349 161.758 216.984L158.314 222.413C157.77 223.18 156.765 223.433 156.183 223.094Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M160.028 236.159L154.216 232.768C153.635 232.429 152.826 231.304 153.677 230.119L156.781 225.226C157.121 224.71 158.18 224.523 158.762 224.862L164.925 228.429C165.506 228.768 165.792 229.413 165.603 230.049L162.158 235.477C161.615 236.243 160.61 236.498 160.028 236.159Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M150.977 230.959L145.164 227.568C144.583 227.229 143.774 226.104 144.625 224.919L147.729 220.026C148.069 219.51 149.129 219.323 149.71 219.662L155.872 223.229C156.453 223.568 156.74 224.213 156.551 224.849L153.107 230.278C152.563 231.044 151.559 231.298 150.977 230.959Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M172.86 254.557L167.047 251.166C166.465 250.827 165.657 249.702 166.508 248.517L169.612 243.624C169.952 243.108 171.012 242.921 171.593 243.26L177.756 246.826C178.337 247.165 178.623 247.81 178.433 248.446L174.989 253.875C174.446 254.641 173.441 254.896 172.86 254.557Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M163.812 249.356L158 245.965C157.419 245.626 156.61 244.501 157.461 243.316L160.565 238.423C160.905 237.908 161.964 237.72 162.546 238.059L168.708 241.626C169.289 241.965 169.576 242.61 169.387 243.246L165.943 248.675C165.399 249.441 164.394 249.695 163.812 249.356Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M154.838 244.068L149.025 240.677C148.444 240.338 147.636 239.213 148.486 238.027L151.59 233.135C151.93 232.619 152.99 232.432 153.571 232.771L159.734 236.337C160.315 236.676 160.601 237.321 160.412 237.957L156.968 243.386C156.425 244.152 155.42 244.407 154.838 244.068Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M145.786 238.867L139.973 235.476C139.392 235.137 138.584 234.012 139.434 232.827L142.538 227.934C142.878 227.418 143.938 227.231 144.519 227.57L150.681 231.137C151.262 231.476 151.549 232.121 151.359 232.757L147.916 238.185C147.373 238.951 146.367 239.206 145.786 238.867Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M176.569 180.71L141.952 236.515L176.569 180.71Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M176.569 180.71L141.952 236.515L176.569 180.71Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M178.828 182.102L144.211 237.907L178.828 182.102Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M178.828 182.102L144.211 237.907L178.828 182.102Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M185.466 186.026L150.849 241.831L185.466 186.026Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M185.466 186.026L150.849 241.831L185.466 186.026Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M187.722 187.418L153.105 243.223L187.722 187.418Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M187.722 187.418L153.105 243.223L187.722 187.418Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M194.361 191.217L159.745 247.021L194.361 191.217Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M194.361 191.217L159.745 247.021L194.361 191.217Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M196.617 192.608L162 248.412L196.617 192.608Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M196.617 192.608L162 248.412L196.617 192.608Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M203.255 196.407L168.638 252.211L203.255 196.407Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M203.255 196.407L168.638 252.211L203.255 196.407Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M205.509 197.799L170.892 253.604L205.509 197.799Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M205.509 197.799L170.892 253.604L205.509 197.799Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M173.718 178.642L173.529 178.743L209.709 199.889L209.882 199.787L173.718 178.642Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M173.531 178.742L173.47 178.95L209.479 199.927L209.51 199.79L173.531 178.742Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M209.707 199.887L209.88 199.787L174.778 255.806L174.397 256.036L209.707 199.887Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M209.705 199.887L209.537 199.789L174.24 255.945L174.395 256.036L209.705 199.887Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M173.717 179.092L173.865 179.18L138.396 234.736L138.171 234.822L173.717 179.092Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    d: "M173.779 178.884L173.53 178.739L137.892 234.66L138.17 234.822L173.779 178.884Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M138.469 234.504L138.248 234.565L174.294 255.771L174.34 255.627L138.469 234.504Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    d: "M138.25 234.564L138.171 234.821L174.242 255.946L174.297 255.77L138.25 234.564Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M211.66 199.305L212.964 201.099L177.393 260.217L176.079 258.436L211.66 199.305Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    d: "M176.087 258.424L177.391 260.217L138.29 237.412L136.5 235.497L176.087 258.424Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M235.609 284.673L218.075 286.552L180.038 264.842L227.243 234.935L274.54 262.132L235.609 284.673Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    d: "M208.175 271.571C208.175 274.12 204.446 276.187 199.847 276.187C195.247 276.187 191.519 274.12 191.519 271.571C191.519 269.021 195.247 266.954 199.847 266.954C204.446 266.954 208.175 269.021 208.175 271.571Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    d: "M208.169 271.422C208.171 271.471 208.175 271.522 208.175 271.571C208.175 274.12 204.447 276.187 199.847 276.187C195.248 276.187 191.519 274.12 191.519 271.571V273.84H191.525C191.65 276.329 195.327 278.325 199.847 278.325C204.447 278.325 208.175 276.258 208.175 273.709V271.422H208.169Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    d: "M212.833 199.626L251.236 221.934L215.655 281.062L176.079 258.122L212.833 199.626Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    d: "M213.355 201.447L249.283 222.514L213.974 278.338L178.036 257.13L213.355 201.447Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    d: "M242.935 229.692L237.123 226.301C236.542 225.962 235.733 224.837 236.584 223.652L239.688 218.759C240.028 218.244 241.087 218.056 241.669 218.395L247.831 221.962C248.412 222.301 248.699 222.946 248.51 223.582L245.066 229.011C244.522 229.777 243.517 230.031 242.935 229.692Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    d: "M233.915 224.461L228.103 221.07C227.521 220.731 226.713 219.606 227.564 218.421L230.668 213.528C231.008 213.013 232.067 212.825 232.648 213.164L238.811 216.731C239.392 217.07 239.679 217.715 239.49 218.351L236.045 223.78C235.502 224.546 234.496 224.8 233.915 224.461Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    d: "M237.764 237.525L231.951 234.134C231.37 233.795 230.562 232.67 231.413 231.485L234.517 226.592C234.857 226.076 235.916 225.889 236.498 226.228L242.66 229.794C243.241 230.134 243.528 230.779 243.339 231.414L239.895 236.843C239.351 237.609 238.346 237.864 237.764 237.525Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    d: "M228.713 232.325L222.9 228.935C222.319 228.595 221.51 227.47 222.361 226.285L225.465 221.392C225.805 220.876 226.865 220.689 227.446 221.028L233.609 224.595C234.19 224.934 234.476 225.58 234.287 226.215L230.843 231.643C230.299 232.41 229.295 232.664 228.713 232.325Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    d: "M224.913 219.203L219.101 215.812C218.519 215.473 217.71 214.348 218.562 213.162L221.666 208.27C222.006 207.754 223.065 207.567 223.646 207.906L229.81 211.473C230.391 211.812 230.677 212.457 230.487 213.093L227.043 218.521C226.5 219.287 225.494 219.542 224.913 219.203Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    d: "M215.895 213.971L210.083 210.581C209.501 210.241 208.693 209.116 209.544 207.932L212.647 203.039C212.988 202.523 214.047 202.336 214.629 202.675L220.791 206.242C221.372 206.58 221.659 207.226 221.469 207.861L218.025 213.29C217.482 214.057 216.477 214.311 215.895 213.971Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    d: "M219.741 227.036L213.929 223.645C213.348 223.306 212.539 222.181 213.39 220.996L216.494 216.103C216.834 215.587 217.893 215.4 218.475 215.739L224.637 219.306C225.218 219.645 225.505 220.29 225.316 220.926L221.872 226.354C221.328 227.12 220.323 227.375 219.741 227.036Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    d: "M210.69 221.836L204.877 218.446C204.295 218.106 203.488 216.981 204.338 215.797L207.442 210.903C207.782 210.388 208.842 210.2 209.423 210.54L215.586 214.106C216.168 214.445 216.454 215.09 216.264 215.726L212.82 221.155C212.277 221.921 211.271 222.175 210.69 221.836Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    d: "M232.736 245.478L226.922 242.087C226.341 241.748 225.532 240.623 226.382 239.438L229.487 234.545C229.828 234.029 230.888 233.842 231.469 234.181L237.63 237.747C238.212 238.086 238.498 238.732 238.308 239.367L234.865 244.796C234.322 245.562 233.317 245.817 232.736 245.478Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    d: "M223.719 240.246L217.906 236.855C217.325 236.516 216.516 235.391 217.367 234.206L220.471 229.313C220.811 228.798 221.871 228.61 222.452 228.949L228.614 232.516C229.195 232.855 229.482 233.5 229.293 234.136L225.849 239.565C225.305 240.331 224.301 240.585 223.719 240.246Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    d: "M227.7 253.481L221.888 250.09C221.306 249.751 220.497 248.626 221.349 247.441L224.453 242.548C224.793 242.032 225.852 241.845 226.433 242.184L232.597 245.751C233.178 246.09 233.464 246.735 233.274 247.371L229.83 252.799C229.287 253.565 228.281 253.82 227.7 253.481Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    d: "M218.633 248.319L212.82 244.928C212.238 244.589 211.43 243.464 212.281 242.278L215.385 237.386C215.725 236.87 216.785 236.683 217.366 237.022L223.528 240.589C224.109 240.928 224.396 241.573 224.206 242.209L220.762 247.637C220.219 248.403 219.214 248.658 218.633 248.319Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    d: "M214.708 234.988L208.896 231.597C208.314 231.258 207.506 230.133 208.357 228.948L211.461 224.055C211.801 223.54 212.86 223.352 213.441 223.691L219.604 227.258C220.185 227.597 220.472 228.242 220.282 228.878L216.839 234.307C216.295 235.073 215.289 235.327 214.708 234.988Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    d: "M205.692 229.757L199.879 226.367C199.298 226.027 198.49 224.902 199.34 223.717L202.444 218.824C202.784 218.308 203.844 218.121 204.425 218.461L210.588 222.027C211.17 222.367 211.456 223.012 211.267 223.647L207.823 229.075C207.279 229.842 206.273 230.096 205.692 229.757Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    d: "M209.538 242.964L203.726 239.574C203.144 239.234 202.336 238.109 203.187 236.924L206.291 232.031C206.631 231.515 207.69 231.328 208.271 231.667L214.434 235.234C215.015 235.573 215.302 236.219 215.113 236.854L211.669 242.282C211.125 243.049 210.12 243.303 209.538 242.964Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    d: "M200.488 237.773L194.676 234.382C194.095 234.043 193.286 232.918 194.137 231.732L197.241 226.84C197.581 226.324 198.64 226.137 199.221 226.476L205.385 230.043C205.966 230.382 206.252 231.027 206.063 231.663L202.619 237.091C202.075 237.857 201.07 238.112 200.488 237.773Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    d: "M222.797 261.439L216.985 258.049C216.404 257.709 215.595 256.584 216.446 255.399L219.55 250.507C219.89 249.991 220.949 249.803 221.531 250.143L227.693 253.709C228.274 254.048 228.561 254.693 228.372 255.329L224.928 260.758C224.384 261.524 223.379 261.779 222.797 261.439Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    d: "M213.778 256.209L207.966 252.818C207.384 252.479 206.576 251.354 207.427 250.169L210.531 245.276C210.871 244.76 211.93 244.573 212.511 244.912L218.674 248.479C219.255 248.817 219.542 249.463 219.353 250.098L215.909 255.527C215.365 256.293 214.36 256.548 213.778 256.209Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    d: "M217.628 269.273L211.816 265.882C211.235 265.543 210.426 264.418 211.277 263.233L214.381 258.34C214.721 257.824 215.78 257.637 216.362 257.976L222.524 261.542C223.105 261.881 223.392 262.526 223.202 263.162L219.758 268.591C219.215 269.357 218.21 269.612 217.628 269.273Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    d: "M208.576 264.073L202.763 260.682C202.182 260.343 201.373 259.218 202.224 258.033L205.328 253.14C205.668 252.624 206.728 252.437 207.309 252.776L213.472 256.342C214.053 256.681 214.339 257.326 214.15 257.962L210.706 263.391C210.162 264.157 209.158 264.412 208.576 264.073Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    d: "M204.771 250.95L198.958 247.56C198.376 247.22 197.569 246.095 198.419 244.91L201.523 240.017C201.863 239.501 202.923 239.314 203.504 239.654L209.666 243.22C210.248 243.558 210.534 244.204 210.345 244.839L206.901 250.268C206.358 251.034 205.352 251.289 204.771 250.95Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    d: "M195.755 245.719L189.943 242.329C189.361 241.989 188.553 240.864 189.404 239.679L192.508 234.786C192.848 234.271 193.907 234.083 194.489 234.422L200.651 237.989C201.232 238.328 201.519 238.973 201.329 239.609L197.885 245.038C197.342 245.804 196.337 246.058 195.755 245.719Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    d: "M199.605 258.783L193.793 255.393C193.212 255.053 192.403 253.928 193.254 252.744L196.358 247.85C196.698 247.335 197.758 247.147 198.339 247.487L204.501 251.054C205.082 251.393 205.369 252.038 205.18 252.673L201.736 258.102C201.192 258.869 200.187 259.122 199.605 258.783Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    d: "M190.553 253.584L184.74 250.193C184.159 249.854 183.351 248.729 184.201 247.543L187.305 242.651C187.645 242.135 188.705 241.948 189.286 242.287L195.449 245.854C196.03 246.193 196.316 246.838 196.127 247.474L192.683 252.902C192.139 253.669 191.134 253.923 190.553 253.584Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    d: "M212.437 277.181L206.624 273.791C206.043 273.451 205.234 272.326 206.085 271.141L209.189 266.248C209.529 265.732 210.589 265.545 211.17 265.885L217.332 269.451C217.913 269.791 218.2 270.436 218.011 271.071L214.567 276.499C214.023 277.266 213.019 277.52 212.437 277.181Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    d: "M203.385 271.981L197.572 268.59C196.99 268.251 196.183 267.126 197.034 265.94L200.138 261.048C200.478 260.532 201.537 260.345 202.118 260.684L208.282 264.25C208.863 264.59 209.149 265.235 208.959 265.87L205.515 271.299C204.972 272.065 203.966 272.32 203.385 271.981Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    d: "M194.415 266.691L188.602 263.301C188.021 262.961 187.213 261.836 188.063 260.651L191.167 255.758C191.507 255.242 192.567 255.055 193.148 255.394L199.31 258.961C199.892 259.3 200.178 259.946 199.989 260.581L196.545 266.01C196.002 266.776 194.996 267.03 194.415 266.691Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    d: "M185.361 261.491L179.549 258.1C178.967 257.761 178.159 256.636 179.01 255.451L182.114 250.558C182.454 250.043 183.513 249.855 184.094 250.194L190.258 253.761C190.839 254.1 191.125 254.745 190.936 255.381L187.492 260.81C186.948 261.576 185.943 261.83 185.361 261.491Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    d: "M216.149 203.334L181.532 259.139L216.149 203.334Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    d: "M216.149 203.334L181.532 259.139L216.149 203.334Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    d: "M218.402 204.727L183.785 260.531L218.402 204.727Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_139",
    d: "M218.402 204.727L183.785 260.531L218.402 204.727Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_140",
    d: "M225.043 208.65L190.427 264.454L225.043 208.65Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_141",
    d: "M225.043 208.65L190.427 264.454L225.043 208.65Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_142",
    d: "M227.297 210.043L192.68 265.848L227.297 210.043Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_143",
    d: "M227.297 210.043L192.68 265.848L227.297 210.043Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_144",
    d: "M233.939 213.841L199.322 269.645L233.939 213.841Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_145",
    d: "M233.939 213.841L199.322 269.645L233.939 213.841Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_146",
    d: "M236.193 215.232L201.576 271.037L236.193 215.232Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_147",
    d: "M236.193 215.232L201.576 271.037L236.193 215.232Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_148",
    d: "M242.834 219.031L208.217 274.835L242.834 219.031Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_149",
    d: "M242.834 219.031L208.217 274.835L242.834 219.031Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_150",
    d: "M245.089 220.423L210.472 276.228L245.089 220.423Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_151",
    d: "M245.089 220.423L210.472 276.228L245.089 220.423Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_152",
    d: "M213.295 201.266L213.106 201.367L249.286 222.513L249.459 222.411L213.295 201.266Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_153",
    d: "M213.103 201.366L213.043 201.573L249.052 222.552L249.082 222.415L213.103 201.366Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_154",
    d: "M249.284 222.512L249.457 222.412L214.355 278.431L213.974 278.661L249.284 222.512Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_155",
    d: "M249.286 222.511L249.119 222.414L213.821 278.57L213.976 278.661L249.286 222.511Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_156",
    d: "M213.298 201.716L213.446 201.804L177.977 257.36L177.751 257.446L213.298 201.716Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_157",
    d: "M213.356 201.509L213.107 201.363L177.469 257.283L177.747 257.446L213.356 201.509Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_158",
    d: "M178.048 257.128L177.827 257.189L213.873 278.395L213.918 278.251L178.048 257.128Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_159",
    d: "M177.831 257.189L177.751 257.446L213.823 278.57L213.877 278.395L177.831 257.189Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_160",
    d: "M251.231 221.93L252.535 223.722L216.964 282.841L215.65 281.061L251.231 221.93Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_161",
    d: "M215.666 281.049L216.97 282.841L177.87 260.036L176.079 258.122L215.666 281.049Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_162",
    d: "M133.802 295.976L116.267 297.856L78.2313 276.145L125.436 246.238L172.733 273.436L133.802 295.976Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_163",
    d: "M106.37 282.874C106.37 285.424 102.64 287.491 98.0414 287.491C93.4417 287.491 89.7134 285.424 89.7134 282.874C89.7134 280.325 93.4417 278.258 98.0414 278.258C102.64 278.258 106.37 280.325 106.37 282.874Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_164",
    d: "M106.364 282.726C106.366 282.775 106.37 282.826 106.37 282.875C106.37 285.424 102.642 287.491 98.0422 287.491C93.4425 287.491 89.7134 285.424 89.7134 282.875V285.144H89.72C89.8452 287.633 93.5213 289.629 98.0422 289.629C102.642 289.629 106.37 287.562 106.37 285.013V282.726H106.364Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_165",
    d: "M111.026 210.93L149.429 233.238L113.848 292.366L74.2714 269.426L111.026 210.93Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_166",
    d: "M111.55 212.751L147.477 233.817L112.167 289.642L76.2307 268.434L111.55 212.751Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_167",
    d: "M141.128 240.995L135.316 237.605C134.734 237.265 133.926 236.14 134.777 234.956L137.881 230.063C138.221 229.547 139.28 229.359 139.861 229.699L146.025 233.265C146.606 233.604 146.892 234.249 146.703 234.885L143.259 240.314C142.715 241.08 141.71 241.335 141.128 240.995Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_168",
    d: "M132.11 235.765L126.297 232.374C125.716 232.035 124.908 230.91 125.758 229.724L128.862 224.832C129.202 224.316 130.262 224.129 130.843 224.468L137.006 228.034C137.587 228.373 137.873 229.018 137.684 229.654L134.24 235.083C133.696 235.849 132.692 236.104 132.11 235.765Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_169",
    d: "M135.951 248.829L130.138 245.439C129.557 245.099 128.749 243.974 129.6 242.79L132.704 237.896C133.044 237.381 134.103 237.193 134.684 237.532L140.848 241.099C141.429 241.438 141.715 242.083 141.526 242.719L138.082 248.148C137.538 248.914 136.533 249.168 135.951 248.829Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_170",
    d: "M126.905 243.629L121.093 240.239C120.511 239.899 119.703 238.774 120.554 237.589L123.658 232.696C123.998 232.18 125.057 231.993 125.639 232.332L131.801 235.9C132.382 236.238 132.669 236.884 132.479 237.519L129.035 242.948C128.492 243.714 127.487 243.968 126.905 243.629Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_171",
    d: "M123.1 230.507L117.287 227.116C116.706 226.777 115.898 225.652 116.748 224.467L119.852 219.574C120.192 219.059 121.252 218.871 121.833 219.21L127.996 222.777C128.577 223.116 128.863 223.761 128.674 224.397L125.23 229.826C124.686 230.592 123.681 230.846 123.1 230.507Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_172",
    d: "M114.087 225.276L108.274 221.885C107.693 221.546 106.885 220.421 107.735 219.235L110.839 214.343C111.179 213.827 112.239 213.64 112.82 213.979L118.983 217.545C119.564 217.884 119.85 218.529 119.661 219.165L116.217 224.594C115.674 225.36 114.668 225.615 114.087 225.276Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_173",
    d: "M117.936 238.34L112.123 234.949C111.541 234.61 110.734 233.485 111.584 232.3L114.688 227.407C115.028 226.891 116.088 226.704 116.669 227.043L122.831 230.609C123.413 230.949 123.699 231.594 123.51 232.229L120.066 237.658C119.523 238.424 118.517 238.679 117.936 238.34Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_174",
    d: "M108.884 233.14L103.072 229.75C102.49 229.41 101.682 228.285 102.533 227.1L105.637 222.207C105.977 221.691 107.036 221.504 107.617 221.843L113.78 225.41C114.361 225.749 114.648 226.394 114.459 227.03L111.015 232.458C110.471 233.225 109.466 233.479 108.884 233.14Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_175",
    d: "M130.928 256.781L125.115 253.39C124.533 253.051 123.726 251.926 124.576 250.741L127.68 245.848C128.02 245.332 129.08 245.145 129.661 245.484L135.823 249.051C136.405 249.39 136.691 250.035 136.502 250.671L133.058 256.099C132.515 256.865 131.509 257.12 130.928 256.781Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_176",
    d: "M121.913 251.55L116.1 248.159C115.518 247.82 114.711 246.695 115.561 245.511L118.665 240.617C119.005 240.102 120.065 239.914 120.646 240.253L126.809 243.82C127.39 244.159 127.677 244.804 127.487 245.44L124.043 250.869C123.5 251.635 122.494 251.889 121.913 251.55Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_177",
    d: "M125.891 264.784L120.079 261.394C119.498 261.054 118.689 259.929 119.54 258.745L122.644 253.851C122.984 253.336 124.043 253.148 124.625 253.488L130.787 257.054C131.368 257.393 131.655 258.038 131.466 258.674L128.022 264.103C127.478 264.869 126.473 265.123 125.891 264.784Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_178",
    d: "M116.82 259.623L111.007 256.232C110.426 255.893 109.618 254.768 110.468 253.583L113.572 248.69C113.912 248.174 114.972 247.987 115.553 248.326L121.716 251.893C122.297 252.232 122.583 252.877 122.394 253.513L118.95 258.942C118.407 259.708 117.402 259.962 116.82 259.623Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_179",
    d: "M112.903 246.292L107.09 242.901C106.509 242.562 105.701 241.437 106.551 240.252L109.655 235.359C109.995 234.844 111.055 234.656 111.636 234.995L117.798 238.562C118.38 238.901 118.666 239.546 118.477 240.182L115.033 245.611C114.49 246.377 113.485 246.631 112.903 246.292Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_180",
    d: "M103.89 241.062L98.0776 237.671C97.4964 237.332 96.6881 236.207 97.5387 235.021L100.643 230.129C100.983 229.613 102.042 229.426 102.623 229.765L108.786 233.332C109.367 233.671 109.654 234.316 109.465 234.952L106.021 240.38C105.477 241.147 104.472 241.401 103.89 241.062Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_181",
    d: "M107.733 254.268L101.92 250.878C101.339 250.538 100.531 249.413 101.381 248.228L104.485 243.335C104.825 242.819 105.885 242.632 106.466 242.972L112.628 246.539C113.21 246.878 113.496 247.523 113.307 248.158L109.863 253.587C109.32 254.353 108.315 254.607 107.733 254.268Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_182",
    d: "M98.6829 249.077L92.8703 245.686C92.2891 245.347 91.4808 244.222 92.3314 243.037L95.4354 238.144C95.7753 237.629 96.8349 237.441 97.4161 237.78L103.579 241.347C104.16 241.686 104.447 242.331 104.258 242.967L100.814 248.396C100.27 249.162 99.2641 249.416 98.6829 249.077Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_183",
    d: "M120.992 272.742L115.179 269.352C114.597 269.012 113.79 267.887 114.64 266.702L117.744 261.809C118.084 261.294 119.144 261.106 119.725 261.446L125.888 265.012C126.469 265.351 126.755 265.996 126.566 266.632L123.122 272.061C122.579 272.827 121.573 273.081 120.992 272.742Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_184",
    d: "M111.975 267.512L106.162 264.122C105.58 263.782 104.772 262.657 105.623 261.472L108.727 256.579C109.067 256.064 110.127 255.876 110.708 256.216L116.871 259.783C117.452 260.122 117.738 260.767 117.548 261.402L114.104 266.831C113.561 267.598 112.556 267.851 111.975 267.512Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_185",
    d: "M115.816 280.577L110.003 277.186C109.422 276.847 108.613 275.722 109.464 274.537L112.568 269.644C112.908 269.128 113.968 268.941 114.549 269.28L120.712 272.847C121.293 273.186 121.579 273.831 121.39 274.467L117.946 279.895C117.402 280.661 116.398 280.916 115.816 280.577Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_186",
    d: "M106.77 275.376L100.958 271.986C100.376 271.646 99.5681 270.521 100.419 269.337L103.523 264.444C103.863 263.928 104.922 263.74 105.503 264.08L111.666 267.646C112.247 267.985 112.534 268.63 112.344 269.266L108.9 274.695C108.357 275.461 107.351 275.716 106.77 275.376Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_187",
    d: "M102.969 262.253L97.1563 258.863C96.5751 258.523 95.7668 257.398 96.6174 256.213L99.7214 251.32C100.061 250.804 101.121 250.617 101.702 250.957L107.865 254.523C108.447 254.862 108.733 255.507 108.544 256.143L105.1 261.571C104.556 262.338 103.551 262.592 102.969 262.253Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_188",
    d: "M93.9528 257.023L88.1402 253.633C87.559 253.293 86.7507 252.168 87.6013 250.983L90.7053 246.09C91.0452 245.574 92.1048 245.387 92.686 245.726L98.8493 249.293C99.4304 249.632 99.7165 250.277 99.5274 250.913L96.0835 256.341C95.5396 257.107 94.5348 257.362 93.9528 257.023Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_189",
    d: "M97.793 270.087L91.9804 266.696C91.3992 266.357 90.5909 265.232 91.4415 264.046L94.5455 259.154C94.8855 258.638 95.945 258.451 96.5262 258.79L102.689 262.357C103.271 262.696 103.557 263.341 103.367 263.977L99.9229 269.405C99.3798 270.171 98.3742 270.426 97.793 270.087Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_190",
    d: "M88.7472 264.888L82.9346 261.497C82.3534 261.158 81.5451 260.033 82.3957 258.848L85.4998 253.955C85.8397 253.439 86.8992 253.252 87.4804 253.591L93.6429 257.157C94.224 257.496 94.5109 258.141 94.3219 258.777L90.8779 264.206C90.3341 264.972 89.3292 265.227 88.7472 264.888Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_191",
    d: "M110.631 288.485L104.818 285.094C104.236 284.755 103.429 283.63 104.279 282.445L107.383 277.552C107.723 277.037 108.783 276.849 109.364 277.188L115.526 280.755C116.108 281.094 116.394 281.739 116.205 282.375L112.761 287.804C112.218 288.57 111.212 288.824 110.631 288.485Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_192",
    d: "M101.578 283.284L95.7652 279.893C95.184 279.554 94.3757 278.429 95.2263 277.245L98.3303 272.351C98.6702 271.836 99.7298 271.648 100.311 271.987L106.473 275.554C107.055 275.893 107.341 276.538 107.152 277.174L103.708 282.603C103.165 283.369 102.16 283.623 101.578 283.284Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_193",
    d: "M92.6022 277.995L86.7896 274.605C86.2084 274.265 85.4001 273.14 86.2507 271.955L89.3547 267.062C89.6947 266.546 90.7542 266.359 91.3354 266.698L97.4987 270.265C98.0798 270.604 98.3659 271.25 98.1768 271.885L94.7329 277.313C94.189 278.08 93.1842 278.334 92.6022 277.995Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_194",
    d: "M83.5564 272.795L77.7438 269.404C77.1627 269.065 76.3543 267.94 77.2049 266.754L80.309 261.862C80.6489 261.346 81.7084 261.159 82.2896 261.498L88.4521 265.065C89.0332 265.404 89.3201 266.049 89.1302 266.685L85.6863 272.114C85.1433 272.88 84.1376 273.134 83.5564 272.795Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_195",
    d: "M114.34 214.639L79.7228 270.443L114.34 214.639Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_196",
    d: "M114.34 214.639L79.7228 270.443L114.34 214.639Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_197",
    d: "M116.591 216.03L81.9736 271.835L116.591 216.03Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_198",
    d: "M116.591 216.03L81.9736 271.835L116.591 216.03Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_199",
    d: "M123.236 219.954L88.6189 275.759L123.236 219.954Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_200",
    d: "M123.236 219.954L88.6189 275.759L123.236 219.954Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_201",
    d: "M125.49 221.347L90.8729 277.151L125.49 221.347Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_202",
    d: "M125.49 221.347L90.8729 277.151L125.49 221.347Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_203",
    d: "M132.132 225.145L97.515 280.949L132.132 225.145Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_204",
    d: "M132.132 225.145L97.515 280.949L132.132 225.145Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_205",
    d: "M134.383 226.536L99.7662 282.341L134.383 226.536Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_206",
    d: "M134.383 226.536L99.7662 282.341L134.383 226.536Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_207",
    d: "M141.022 230.335L106.405 286.139L141.022 230.335Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_208",
    d: "M141.022 230.335L106.405 286.139L141.022 230.335Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_209",
    d: "M143.283 231.727L108.667 287.531L143.283 231.727Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_210",
    d: "M143.283 231.727L108.667 287.531L143.283 231.727Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_211",
    d: "M111.482 212.57L111.293 212.671L147.474 233.817L147.646 233.715L111.482 212.57Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_212",
    d: "M111.296 212.67L111.236 212.877L147.244 233.854L147.275 233.718L111.296 212.67Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_213",
    d: "M147.472 233.816L147.645 233.716L112.544 289.735L112.162 289.965L147.472 233.816Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_214",
    d: "M147.475 233.815L147.307 233.718L112.011 289.874L112.165 289.965L147.475 233.815Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_215",
    d: "M111.485 213.02L111.633 213.108L76.1639 268.664L75.9384 268.75L111.485 213.02Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_216",
    d: "M111.55 212.813L111.3 212.667L75.6626 268.588L75.9403 268.75L111.55 212.813Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_217",
    d: "M76.2398 268.432L76.0193 268.493L112.065 289.699L112.111 289.555L76.2398 268.432Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_218",
    d: "M76.0179 268.493L75.9384 268.75L112.009 289.875L112.064 289.699L76.0179 268.493Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_219",
    d: "M149.427 233.234L150.731 235.027L115.16 294.145L113.846 292.364L149.427 233.234Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_220",
    d: "M113.859 292.353L115.163 294.145L76.0613 271.34L74.2714 269.426L113.859 292.353Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_221",
    d: "M173.51 318.643L155.976 320.523L117.94 298.812L165.144 268.905L212.442 296.103L173.51 318.643Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_222",
    d: "M146.077 305.539C146.077 308.089 142.348 310.156 137.749 310.156C133.149 310.156 129.42 308.089 129.42 305.539C129.42 302.99 133.149 300.923 137.749 300.923C142.348 300.923 146.077 302.99 146.077 305.539Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_223",
    d: "M146.07 305.392C146.073 305.441 146.077 305.49 146.077 305.54C146.077 308.09 142.348 310.156 137.748 310.156C133.148 310.156 129.42 308.09 129.42 305.54V307.809H129.427C129.552 310.298 133.227 312.295 137.748 312.295C142.348 312.295 146.077 310.228 146.077 307.678V305.392H146.07Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_224",
    d: "M150.728 233.595L189.131 255.904L153.55 315.031L113.974 292.091L150.728 233.595Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_225",
    d: "M151.254 235.417L187.181 256.484L151.872 312.308L115.935 291.1L151.254 235.417Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_226",
    d: "M180.833 263.662L175.02 260.271C174.439 259.932 173.631 258.807 174.481 257.621L177.585 252.729C177.925 252.213 178.985 252.026 179.566 252.365L185.729 255.931C186.31 256.27 186.596 256.915 186.407 257.551L182.963 262.98C182.42 263.746 181.415 264.001 180.833 263.662Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_227",
    d: "M171.814 258.431L166.001 255.041C165.42 254.701 164.612 253.576 165.462 252.391L168.566 247.498C168.906 246.983 169.966 246.795 170.547 247.135L176.709 250.702C177.29 251.041 177.577 251.686 177.388 252.321L173.944 257.75C173.4 258.517 172.396 258.77 171.814 258.431Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_228",
    d: "M175.663 271.496L169.85 268.105C169.269 267.766 168.46 266.641 169.311 265.456L172.415 260.563C172.755 260.047 173.815 259.86 174.396 260.199L180.558 263.765C181.139 264.105 181.426 264.75 181.237 265.385L177.793 270.814C177.249 271.58 176.245 271.835 175.663 271.496Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_229",
    d: "M166.612 266.295L160.799 262.904C160.217 262.565 159.41 261.44 160.26 260.255L163.364 255.362C163.704 254.846 164.764 254.659 165.345 254.998L171.508 258.565C172.089 258.904 172.375 259.549 172.185 260.185L168.742 265.614C168.198 266.38 167.193 266.634 166.612 266.295Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_230",
    d: "M162.808 253.172L156.996 249.781C156.414 249.442 155.606 248.317 156.457 247.132L159.561 242.239C159.901 241.724 160.96 241.536 161.541 241.875L167.704 245.442C168.285 245.781 168.572 246.426 168.383 247.062L164.939 252.491C164.395 253.257 163.39 253.511 162.808 253.172Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_231",
    d: "M153.789 247.942L147.977 244.552C147.396 244.212 146.587 243.087 147.438 241.902L150.542 237.009C150.882 236.493 151.941 236.306 152.523 236.645L158.685 240.211C159.266 240.551 159.553 241.196 159.364 241.831L155.92 247.26C155.376 248.026 154.371 248.281 153.789 247.942Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_232",
    d: "M157.64 261.006L151.827 257.616C151.245 257.276 150.438 256.151 151.288 254.966L154.392 250.074C154.732 249.558 155.792 249.37 156.373 249.71L162.535 253.276C163.117 253.615 163.403 254.26 163.214 254.896L159.77 260.325C159.227 261.091 158.221 261.346 157.64 261.006Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_233",
    d: "M148.587 255.806L142.774 252.415C142.193 252.076 141.385 250.951 142.235 249.767L145.339 244.873C145.679 244.358 146.739 244.17 147.32 244.509L153.482 248.076C154.064 248.415 154.35 249.06 154.161 249.696L150.718 255.125C150.174 255.891 149.169 256.145 148.587 255.806Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_234",
    d: "M170.636 279.447L164.824 276.056C164.242 275.717 163.434 274.592 164.285 273.407L167.389 268.514C167.729 267.998 168.788 267.811 169.369 268.15L175.532 271.716C176.113 272.055 176.4 272.7 176.21 273.336L172.767 278.765C172.223 279.531 171.217 279.786 170.636 279.447Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_235",
    d: "M161.617 274.216L155.804 270.826C155.223 270.486 154.415 269.361 155.265 268.176L158.369 263.283C158.709 262.768 159.769 262.58 160.35 262.92L166.512 266.486C167.094 266.825 167.381 267.47 167.191 268.106L163.747 273.535C163.204 274.301 162.198 274.555 161.617 274.216Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_236",
    d: "M165.603 287.451L159.79 284.06C159.209 283.721 158.401 282.596 159.252 281.411L162.356 276.518C162.696 276.002 163.755 275.815 164.336 276.154L170.499 279.721C171.08 280.06 171.367 280.705 171.178 281.341L167.734 286.769C167.19 287.535 166.185 287.79 165.603 287.451Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_237",
    d: "M156.528 282.288L150.716 278.898C150.134 278.558 149.326 277.433 150.177 276.248L153.281 271.356C153.621 270.84 154.68 270.652 155.261 270.992L161.424 274.558C162.005 274.897 162.292 275.542 162.103 276.178L158.659 281.607C158.115 282.373 157.11 282.628 156.528 282.288Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_238",
    d: "M152.608 268.957L146.796 265.566C146.215 265.227 145.406 264.102 146.257 262.917L149.361 258.024C149.701 257.509 150.76 257.321 151.342 257.66L157.504 261.227C158.085 261.566 158.372 262.211 158.183 262.847L154.739 268.276C154.195 269.042 153.19 269.296 152.608 268.957Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_239",
    d: "M143.594 263.727L137.781 260.337C137.2 259.997 136.392 258.872 137.242 257.687L140.346 252.794C140.686 252.278 141.746 252.091 142.327 252.43L148.49 255.996C149.071 256.336 149.358 256.981 149.169 257.616L145.725 263.045C145.181 263.811 144.176 264.066 143.594 263.727Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_240",
    d: "M147.439 276.934L141.627 273.544C141.045 273.204 140.237 272.079 141.088 270.894L144.192 266.001C144.532 265.485 145.591 265.298 146.173 265.637L152.335 269.203C152.916 269.542 153.203 270.187 153.013 270.823L149.569 276.252C149.026 277.018 148.021 277.273 147.439 276.934Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_241",
    d: "M138.394 271.742L132.582 268.352C132.001 268.012 131.192 266.887 132.043 265.703L135.147 260.81C135.487 260.294 136.546 260.106 137.128 260.446L143.291 264.012C143.872 264.351 144.158 264.997 143.969 265.632L140.525 271.061C139.981 271.827 138.976 272.082 138.394 271.742Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_242",
    d: "M160.694 295.409L154.882 292.019C154.3 291.679 153.492 290.554 154.343 289.369L157.447 284.476C157.787 283.961 158.846 283.773 159.427 284.113L165.59 287.68C166.171 288.018 166.458 288.664 166.268 289.299L162.824 294.728C162.281 295.495 161.275 295.748 160.694 295.409Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_243",
    d: "M151.684 290.179L145.872 286.788C145.29 286.449 144.482 285.324 145.333 284.139L148.437 279.246C148.777 278.73 149.836 278.543 150.417 278.882L156.58 282.448C157.161 282.787 157.448 283.432 157.258 284.068L153.814 289.497C153.271 290.263 152.265 290.518 151.684 290.179Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_244",
    d: "M155.526 303.243L149.713 299.852C149.132 299.513 148.323 298.388 149.174 297.202L152.278 292.31C152.618 291.794 153.678 291.607 154.259 291.946L160.421 295.513C161.002 295.852 161.289 296.497 161.1 297.133L157.656 302.561C157.112 303.328 156.108 303.582 155.526 303.243Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_245",
    d: "M146.473 298.042L140.66 294.651C140.079 294.312 139.271 293.187 140.121 292.002L143.225 287.109C143.565 286.593 144.625 286.406 145.206 286.745L151.369 290.312C151.95 290.651 152.236 291.296 152.047 291.932L148.604 297.36C148.06 298.126 147.054 298.381 146.473 298.042Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_246",
    d: "M142.676 284.92L136.863 281.53C136.282 281.19 135.473 280.065 136.324 278.88L139.428 273.987C139.768 273.471 140.828 273.284 141.409 273.623L147.571 277.19C148.152 277.529 148.439 278.174 148.25 278.81L144.806 284.238C144.262 285.004 143.258 285.259 142.676 284.92Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_247",
    d: "M133.66 279.689L127.848 276.298C127.266 275.959 126.458 274.834 127.309 273.649L130.413 268.756C130.753 268.24 131.812 268.053 132.393 268.392L138.556 271.959C139.137 272.298 139.424 272.943 139.235 273.579L135.791 279.007C135.247 279.773 134.242 280.028 133.66 279.689Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_248",
    d: "M137.503 292.754L131.69 289.364C131.109 289.024 130.3 287.899 131.151 286.714L134.255 281.821C134.595 281.305 135.655 281.118 136.236 281.457L142.398 285.024C142.979 285.363 143.266 286.009 143.077 286.644L139.633 292.073C139.089 292.839 138.084 293.093 137.503 292.754Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_249",
    d: "M128.453 287.554L122.64 284.163C122.059 283.824 121.251 282.699 122.101 281.513L125.205 276.621C125.545 276.105 126.605 275.918 127.186 276.257L133.348 279.824C133.93 280.163 134.216 280.808 134.027 281.444L130.583 286.872C130.04 287.638 129.035 287.893 128.453 287.554Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_250",
    d: "M150.335 311.151L144.522 307.761C143.94 307.421 143.133 306.296 143.984 305.111L147.088 300.218C147.427 299.702 148.487 299.515 149.068 299.854L155.231 303.42C155.812 303.76 156.099 304.405 155.909 305.04L152.465 310.469C151.922 311.235 150.916 311.49 150.335 311.151Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_251",
    d: "M141.29 305.95L135.477 302.559C134.896 302.22 134.088 301.095 134.938 299.91L138.042 295.017C138.382 294.502 139.442 294.314 140.023 294.653L146.185 298.22C146.767 298.559 147.053 299.204 146.864 299.84L143.421 305.269C142.877 306.035 141.872 306.289 141.29 305.95Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_252",
    d: "M132.312 300.662L126.499 297.271C125.918 296.932 125.11 295.807 125.96 294.622L129.064 289.729C129.404 289.213 130.464 289.026 131.045 289.365L137.208 292.932C137.789 293.271 138.076 293.916 137.887 294.552L134.443 299.98C133.899 300.746 132.894 301.001 132.312 300.662Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_253",
    d: "M123.262 295.461L117.45 292.071C116.868 291.731 116.06 290.606 116.911 289.421L120.015 284.528C120.355 284.012 121.414 283.825 121.995 284.164L128.159 287.732C128.74 288.07 129.026 288.716 128.836 289.351L125.392 294.78C124.849 295.546 123.843 295.8 123.262 295.461Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_254",
    d: "M154.046 237.304L119.429 293.109L154.046 237.304Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_255",
    d: "M154.046 237.304L119.429 293.109L154.046 237.304Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_256",
    d: "M156.298 238.697L121.681 294.501L156.298 238.697Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_257",
    d: "M156.298 238.697L121.681 294.501L156.298 238.697Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_258",
    d: "M162.94 242.621L128.323 298.425L162.94 242.621Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_259",
    d: "M162.94 242.621L128.323 298.425L162.94 242.621Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_260",
    d: "M165.192 244.012L130.576 299.816L165.192 244.012Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_261",
    d: "M165.192 244.012L130.576 299.816L165.192 244.012Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_262",
    d: "M171.839 247.81L137.222 303.615L171.839 247.81Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_263",
    d: "M171.839 247.81L137.222 303.615L171.839 247.81Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_264",
    d: "M174.09 249.203L139.473 305.008L174.09 249.203Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_265",
    d: "M174.09 249.203L139.473 305.008L174.09 249.203Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_266",
    d: "M180.732 253.001L146.115 308.805L180.732 253.001Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_267",
    d: "M180.732 253.001L146.115 308.805L180.732 253.001Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_268",
    d: "M182.986 254.393L148.369 310.197L182.986 254.393Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_269",
    d: "M182.986 254.393L148.369 310.197L182.986 254.393Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_270",
    d: "M151.194 235.236L151.005 235.337L187.185 256.483L187.358 256.381L151.194 235.236Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_271",
    d: "M151.003 235.336L150.943 235.543L186.951 256.522L186.982 256.384L151.003 235.336Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_272",
    d: "M187.184 256.482L187.358 256.382L152.256 312.401L151.874 312.631L187.184 256.482Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_273",
    d: "M187.178 256.482L187.01 256.384L151.713 312.54L151.868 312.631L187.178 256.482Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_274",
    d: "M151.194 235.686L151.343 235.774L115.874 291.33L115.648 291.416L151.194 235.686Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_275",
    d: "M151.252 235.478L151.003 235.332L115.365 291.252L115.643 291.416L151.252 235.478Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_276",
    d: "M115.946 291.098L115.725 291.159L151.772 312.365L151.817 312.221L115.946 291.098Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_277",
    d: "M115.728 291.159L115.648 291.416L151.719 312.541L151.774 312.365L115.728 291.159Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_278",
    d: "M189.136 255.9L190.44 257.693L154.869 316.812L153.555 315.031L189.136 255.9Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_279",
    d: "M153.561 315.018L154.865 316.811L115.764 294.006L113.974 292.091L153.561 315.018Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_280",
    d: "M275.447 307.702L257.913 309.582L219.877 287.871L267.08 257.964L314.379 285.162L275.447 307.702Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_281",
    d: "M248.014 294.601C248.014 297.15 244.285 299.217 239.685 299.217C235.085 299.217 231.357 297.15 231.357 294.601C231.357 292.051 235.085 289.984 239.685 289.984C244.285 289.984 248.014 292.051 248.014 294.601Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_282",
    d: "M248.01 294.453C248.013 294.501 248.018 294.552 248.018 294.601C248.018 297.15 244.288 299.217 239.689 299.217C235.089 299.217 231.361 297.15 231.361 294.601V296.87H231.367C231.492 299.359 235.169 301.355 239.689 301.355C244.288 301.355 248.018 299.288 248.018 296.739V294.453H248.01Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_283",
    d: "M252.667 222.655L291.07 244.964L255.489 304.091L215.913 281.152L252.667 222.655Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_284",
    d: "M253.189 224.476L289.116 245.543L253.807 301.367L217.87 280.16L253.189 224.476Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_285",
    d: "M282.77 252.722L276.957 249.331C276.375 248.992 275.567 247.867 276.419 246.682L279.522 241.789C279.863 241.273 280.922 241.086 281.503 241.425L287.667 244.992C288.248 245.331 288.534 245.976 288.345 246.612L284.9 252.04C284.357 252.807 283.351 253.061 282.77 252.722Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_286",
    d: "M273.75 247.491L267.938 244.1C267.356 243.761 266.548 242.636 267.399 241.451L270.503 236.558C270.843 236.042 271.902 235.855 272.484 236.194L278.646 239.761C279.227 240.1 279.514 240.745 279.325 241.381L275.881 246.81C275.337 247.576 274.332 247.83 273.75 247.491Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_287",
    d: "M277.6 260.556L271.787 257.166C271.206 256.826 270.397 255.701 271.249 254.516L274.352 249.623C274.693 249.108 275.752 248.92 276.333 249.259L282.496 252.826C283.078 253.165 283.364 253.81 283.175 254.446L279.73 259.875C279.186 260.641 278.181 260.895 277.6 260.556Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_288",
    d: "M268.549 255.356L262.736 251.965C262.154 251.626 261.346 250.5 262.197 249.316L265.301 244.423C265.641 243.907 266.701 243.72 267.282 244.059L273.444 247.626C274.025 247.964 274.311 248.61 274.122 249.245L270.679 254.674C270.135 255.441 269.13 255.695 268.549 255.356Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_289",
    d: "M264.75 242.233L258.937 238.842C258.356 238.503 257.547 237.378 258.399 236.193L261.502 231.3C261.843 230.784 262.902 230.597 263.483 230.936L269.646 234.502C270.228 234.841 270.514 235.487 270.325 236.122L266.88 241.551C266.336 242.317 265.331 242.572 264.75 242.233Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_290",
    d: "M255.734 237.002L249.921 233.611C249.34 233.272 248.532 232.147 249.382 230.961L252.486 226.069C252.826 225.553 253.886 225.366 254.468 225.705L260.629 229.272C261.21 229.611 261.497 230.256 261.308 230.892L257.864 236.32C257.321 237.086 256.316 237.341 255.734 237.002Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_291",
    d: "M259.576 250.067L253.762 246.676C253.181 246.337 252.373 245.212 253.224 244.027L256.327 239.134C256.667 238.618 257.728 238.431 258.309 238.77L264.47 242.337C265.052 242.676 265.338 243.321 265.149 243.957L261.705 249.385C261.162 250.151 260.157 250.406 259.576 250.067Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_292",
    d: "M250.527 244.866L244.714 241.476C244.133 241.136 243.325 240.011 244.175 238.826L247.279 233.933C247.619 233.417 248.679 233.23 249.261 233.569L255.423 237.136C256.004 237.475 256.29 238.12 256.101 238.756L252.657 244.184C252.114 244.95 251.109 245.205 250.527 244.866Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_293",
    d: "M272.573 268.508L266.76 265.117C266.179 264.778 265.371 263.653 266.222 262.468L269.326 257.575C269.665 257.059 270.725 256.872 271.306 257.211L277.469 260.777C278.05 261.117 278.337 261.762 278.148 262.397L274.703 267.826C274.16 268.592 273.154 268.847 272.573 268.508Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_294",
    d: "M263.554 263.277L257.741 259.886C257.16 259.547 256.351 258.422 257.203 257.237L260.306 252.344C260.646 251.828 261.706 251.641 262.287 251.98L268.449 255.547C269.031 255.886 269.316 256.531 269.127 257.167L265.684 262.596C265.14 263.362 264.135 263.616 263.554 263.277Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_295",
    d: "M267.539 276.51L261.726 273.119C261.145 272.78 260.336 271.655 261.188 270.47L264.291 265.577C264.632 265.062 265.691 264.874 266.272 265.213L272.435 268.78C273.017 269.119 273.303 269.764 273.114 270.4L269.669 275.829C269.125 276.595 268.12 276.849 267.539 276.51Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_296",
    d: "M258.46 271.349L252.646 267.958C252.065 267.619 251.257 266.494 252.108 265.309L255.212 260.416C255.552 259.9 256.612 259.713 257.193 260.052L263.356 263.619C263.937 263.958 264.223 264.603 264.034 265.239L260.59 270.667C260.046 271.433 259.041 271.688 258.46 271.349Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_297",
    d: "M254.552 258.018L248.739 254.627C248.157 254.288 247.349 253.163 248.2 251.979L251.303 247.085C251.644 246.57 252.704 246.382 253.285 246.721L259.448 250.288C260.029 250.627 260.315 251.272 260.126 251.908L256.682 257.337C256.139 258.103 255.133 258.357 254.552 258.018Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_298",
    d: "M245.533 252.787L239.721 249.397C239.14 249.057 238.331 247.932 239.183 246.747L242.286 241.855C242.626 241.339 243.685 241.151 244.267 241.491L250.429 245.057C251.01 245.396 251.297 246.041 251.108 246.677L247.664 252.106C247.12 252.872 246.115 253.127 245.533 252.787Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_299",
    d: "M249.376 265.993L243.563 262.603C242.981 262.263 242.173 261.138 243.024 259.954L246.128 255.061C246.468 254.545 247.528 254.357 248.109 254.697L254.272 258.264C254.853 258.603 255.139 259.248 254.95 259.883L251.506 265.312C250.963 266.079 249.957 266.333 249.376 265.993Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_300",
    d: "M240.329 260.803L234.515 257.412C233.934 257.073 233.126 255.948 233.977 254.762L237.081 249.87C237.421 249.354 238.481 249.167 239.062 249.506L245.224 253.073C245.806 253.412 246.093 254.057 245.903 254.693L242.459 260.121C241.915 260.887 240.91 261.142 240.329 260.803Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_301",
    d: "M262.633 284.469L256.82 281.078C256.239 280.739 255.43 279.614 256.282 278.429L259.385 273.536C259.725 273.021 260.785 272.833 261.366 273.172L267.528 276.739C268.109 277.078 268.395 277.723 268.206 278.359L264.763 283.788C264.219 284.554 263.214 284.808 262.633 284.469Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_302",
    d: "M253.62 279.238L247.807 275.848C247.225 275.508 246.418 274.383 247.268 273.199L250.372 268.305C250.712 267.79 251.772 267.602 252.353 267.942L258.515 271.509C259.097 271.848 259.384 272.493 259.194 273.128L255.75 278.557C255.207 279.324 254.201 279.577 253.62 279.238Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_303",
    d: "M314.492 331.806L296.958 333.685L258.921 311.975L306.126 282.068L353.423 309.265L314.492 331.806Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_304",
    d: "M257.462 292.304L251.65 288.913C251.069 288.574 250.26 287.449 251.111 286.264L254.215 281.371C254.555 280.855 255.614 280.668 256.196 281.007L262.358 284.573C262.939 284.912 263.226 285.557 263.037 286.193L259.593 291.622C259.049 292.388 258.044 292.643 257.462 292.304Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_305",
    d: "M248.418 287.103L242.605 283.712C242.024 283.373 241.216 282.248 242.066 281.063L245.17 276.17C245.51 275.654 246.57 275.467 247.152 275.806L253.314 279.373C253.895 279.712 254.181 280.357 253.992 280.993L250.548 286.421C250.004 287.187 248.999 287.442 248.418 287.103Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_306",
    d: "M244.61 273.979L238.797 270.589C238.216 270.249 237.408 269.124 238.258 267.94L241.362 263.046C241.702 262.531 242.762 262.343 243.344 262.683L249.505 266.25C250.086 266.589 250.373 267.234 250.184 267.869L246.74 273.298C246.196 274.065 245.192 274.318 244.61 273.979Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_307",
    d: "M235.591 268.749L229.779 265.359C229.197 265.019 228.389 263.894 229.24 262.709L232.343 257.816C232.684 257.3 233.743 257.113 234.324 257.452L240.487 261.018C241.068 261.357 241.355 262.003 241.166 262.638L237.721 268.067C237.177 268.833 236.172 269.088 235.591 268.749Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_308",
    d: "M239.443 281.814L233.63 278.423C233.049 278.084 232.24 276.959 233.091 275.773L236.195 270.881C236.535 270.365 237.595 270.178 238.177 270.517L244.338 274.084C244.919 274.423 245.206 275.068 245.017 275.704L241.572 281.132C241.029 281.899 240.024 282.153 239.443 281.814Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_309",
    d: "M230.39 276.613L224.577 273.222C223.996 272.883 223.188 271.758 224.038 270.574L227.142 265.68C227.482 265.165 228.542 264.977 229.123 265.316L235.286 268.883C235.867 269.222 236.153 269.867 235.964 270.503L232.52 275.932C231.977 276.698 230.971 276.952 230.39 276.613Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_310",
    d: "M252.272 300.211L246.459 296.82C245.878 296.481 245.069 295.356 245.921 294.17L249.024 289.278C249.364 288.762 250.424 288.575 251.005 288.914L257.167 292.48C257.749 292.82 258.034 293.465 257.845 294.1L254.402 299.529C253.858 300.295 252.853 300.55 252.272 300.211Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_311",
    d: "M243.221 295.011L237.408 291.62C236.827 291.281 236.019 290.156 236.869 288.971L239.973 284.078C240.313 283.562 241.373 283.375 241.955 283.714L248.117 287.28C248.698 287.62 248.984 288.265 248.795 288.9L245.351 294.329C244.808 295.095 243.803 295.35 243.221 295.011Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_312",
    d: "M234.252 289.721L228.439 286.331C227.858 285.991 227.05 284.866 227.9 283.682L231.004 278.788C231.344 278.273 232.404 278.085 232.986 278.425L239.148 281.992C239.729 282.33 240.016 282.976 239.827 283.611L236.383 289.04C235.839 289.806 234.834 290.06 234.252 289.721Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_313",
    d: "M225.199 284.522L219.386 281.131C218.805 280.792 217.997 279.667 218.848 278.481L221.952 273.589C222.291 273.073 223.351 272.886 223.932 273.225L230.095 276.792C230.677 277.131 230.963 277.776 230.774 278.412L227.33 283.84C226.786 284.606 225.781 284.861 225.199 284.522Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_314",
    d: "M255.984 226.366L221.368 282.17L255.984 226.366Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_315",
    d: "M255.984 226.366L221.368 282.17L255.984 226.366Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_316",
    d: "M258.24 227.757L223.623 283.562L258.24 227.757Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_317",
    d: "M258.24 227.757L223.623 283.562L258.24 227.757Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_318",
    d: "M264.879 231.68L230.262 287.484L264.879 231.68Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_319",
    d: "M264.879 231.68L230.262 287.484L264.879 231.68Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_320",
    d: "M267.131 233.073L232.514 288.878L267.131 233.073Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_321",
    d: "M267.131 233.073L232.514 288.878L267.131 233.073Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_322",
    d: "M273.776 236.871L239.159 292.676L273.776 236.871Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_323",
    d: "M273.776 236.871L239.159 292.676L273.776 236.871Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_324",
    d: "M276.034 238.263L241.416 294.067L276.034 238.263Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_325",
    d: "M276.034 238.263L241.416 294.067L276.034 238.263Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_326",
    d: "M282.669 242.061L248.052 297.866L282.669 242.061Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_327",
    d: "M282.669 242.061L248.052 297.866L282.669 242.061Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_328",
    d: "M284.922 243.453L250.305 299.258L284.922 243.453Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_329",
    d: "M284.922 243.453L250.305 299.258L284.922 243.453Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_330",
    d: "M253.132 224.296L252.942 224.397L289.123 245.543L289.296 245.441L253.132 224.296Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_331",
    d: "M252.94 224.397L252.88 224.604L288.888 245.581L288.919 245.444L252.94 224.397Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_332",
    d: "M289.12 245.542L289.294 245.442L254.191 301.46L253.81 301.691L289.12 245.542Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_333",
    d: "M289.118 245.542L288.95 245.444L253.653 301.6L253.808 301.691L289.118 245.542Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_334",
    d: "M253.133 224.747L253.282 224.835L217.812 280.39L217.587 280.477L253.133 224.747Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_335",
    d: "M253.193 224.54L252.944 224.394L217.306 280.314L217.584 280.477L253.193 224.54Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_336",
    d: "M217.884 280.157L217.662 280.219L253.708 301.425L253.754 301.28L217.884 280.157Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_337",
    d: "M217.667 280.219L217.587 280.476L253.659 301.601L253.713 301.425L217.667 280.219Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_338",
    d: "M291.073 244.96L292.376 246.754L256.807 305.872L255.493 304.091L291.073 244.96Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_339",
    d: "M255.5 304.08L256.804 305.872L217.704 283.067L215.913 281.153L255.5 304.08Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_340",
    d: "M213.346 341.673L195.812 343.552L157.775 321.841L204.98 291.934L252.277 319.132L213.346 341.673Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_341",
    d: "M185.912 328.57C185.912 331.119 182.183 333.186 177.584 333.186C172.984 333.186 169.255 331.119 169.255 328.57C169.255 326.021 172.984 323.954 177.584 323.954C182.183 323.954 185.912 326.021 185.912 328.57Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_342",
    d: "M185.905 328.422C185.908 328.471 185.912 328.521 185.912 328.57C185.912 331.12 182.183 333.187 177.583 333.187C172.983 333.187 169.255 331.12 169.255 328.57V330.839H169.262C169.387 333.328 173.062 335.325 177.583 335.325C182.183 335.325 185.912 333.258 185.912 330.708V328.422H185.905Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_343",
    d: "M190.565 256.625L228.968 278.934L193.387 338.061L153.811 315.121L190.565 256.625Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_344",
    d: "M191.092 258.447L227.019 279.513L191.71 335.338L155.773 314.13L191.092 258.447Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_345",
    d: "M220.668 286.692L214.855 283.301C214.274 282.962 213.466 281.837 214.316 280.652L217.42 275.759C217.76 275.243 218.82 275.056 219.401 275.395L225.564 278.961C226.145 279.3 226.432 279.945 226.243 280.581L222.799 286.01C222.255 286.776 221.25 287.031 220.668 286.692Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_346",
    d: "M211.652 281.461L205.84 278.07C205.258 277.731 204.45 276.606 205.301 275.42L208.405 270.528C208.745 270.012 209.804 269.825 210.385 270.164L216.548 273.73C217.129 274.07 217.416 274.715 217.227 275.35L213.783 280.779C213.239 281.545 212.234 281.8 211.652 281.461Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_347",
    d: "M215.496 294.525L209.684 291.134C209.103 290.795 208.294 289.67 209.145 288.485L212.249 283.592C212.589 283.077 213.648 282.889 214.23 283.228L220.392 286.795C220.973 287.134 221.26 287.779 221.071 288.415L217.627 293.844C217.083 294.61 216.078 294.864 215.496 294.525Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_348",
    d: "M206.451 289.325L200.638 285.935C200.056 285.595 199.249 284.47 200.1 283.286L203.204 278.392C203.543 277.877 204.603 277.689 205.184 278.029L211.347 281.595C211.929 281.934 212.215 282.579 212.025 283.215L208.581 288.644C208.038 289.41 207.032 289.664 206.451 289.325Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_349",
    d: "M202.645 276.203L196.833 272.812C196.252 272.473 195.443 271.348 196.294 270.162L199.398 265.27C199.738 264.754 200.797 264.567 201.378 264.906L207.541 268.472C208.122 268.812 208.409 269.457 208.22 270.092L204.776 275.521C204.232 276.287 203.227 276.542 202.645 276.203Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_350",
    d: "M193.631 270.972L187.818 267.582C187.237 267.242 186.428 266.117 187.279 264.932L190.383 260.039C190.723 259.523 191.783 259.336 192.364 259.675L198.526 263.243C199.107 263.581 199.394 264.227 199.205 264.862L195.761 270.291C195.217 271.057 194.213 271.311 193.631 270.972Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_351",
    d: "M197.475 284.036L191.663 280.645C191.081 280.306 190.273 279.181 191.124 277.996L194.228 273.103C194.568 272.588 195.627 272.4 196.209 272.739L202.371 276.306C202.952 276.645 203.239 277.29 203.049 277.926L199.605 283.355C199.062 284.121 198.057 284.375 197.475 284.036Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_352",
    d: "M188.43 278.836L182.617 275.445C182.036 275.106 181.228 273.981 182.078 272.796L185.182 267.903C185.522 267.387 186.582 267.2 187.163 267.539L193.326 271.106C193.907 271.445 194.194 272.09 194.004 272.726L190.561 278.155C190.017 278.921 189.012 279.175 188.43 278.836Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_353",
    d: "M210.47 302.478L204.657 299.087C204.076 298.748 203.268 297.623 204.118 296.438L207.222 291.545C207.562 291.029 208.622 290.842 209.203 291.181L215.365 294.747C215.946 295.087 216.233 295.732 216.044 296.367L212.6 301.796C212.056 302.562 211.051 302.817 210.47 302.478Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_354",
    d: "M201.452 297.247L195.64 293.856C195.059 293.517 194.25 292.392 195.101 291.206L198.205 286.314C198.545 285.798 199.604 285.611 200.186 285.95L206.349 289.517C206.93 289.856 207.216 290.501 207.027 291.137L203.582 296.565C203.039 297.331 202.034 297.586 201.452 297.247Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_355",
    d: "M205.44 310.48L199.627 307.09C199.046 306.751 198.238 305.625 199.088 304.441L202.193 299.548C202.532 299.032 203.592 298.845 204.173 299.184L210.336 302.75C210.917 303.089 211.204 303.734 211.015 304.37L207.571 309.799C207.027 310.565 206.022 310.82 205.44 310.48Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_356",
    d: "M196.364 305.319L190.551 301.928C189.97 301.589 189.161 300.464 190.012 299.278L193.116 294.386C193.456 293.87 194.516 293.683 195.097 294.022L201.259 297.589C201.84 297.928 202.127 298.573 201.938 299.209L198.494 304.637C197.95 305.403 196.946 305.658 196.364 305.319Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_357",
    d: "M192.448 291.988L186.636 288.597C186.055 288.258 185.246 287.133 186.097 285.948L189.201 281.055C189.541 280.54 190.6 280.352 191.182 280.691L197.344 284.258C197.925 284.597 198.212 285.242 198.023 285.878L194.579 291.307C194.035 292.073 193.03 292.327 192.448 291.988Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_358",
    d: "M183.43 286.757L177.618 283.367C177.036 283.027 176.227 281.902 177.079 280.717L180.183 275.824C180.523 275.309 181.582 275.121 182.164 275.46L188.327 279.028C188.908 279.367 189.194 280.012 189.004 280.647L185.56 286.076C185.017 286.843 184.012 287.096 183.43 286.757Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_359",
    d: "M187.278 299.963L181.466 296.573C180.884 296.233 180.076 295.108 180.927 293.924L184.031 289.03C184.371 288.515 185.43 288.327 186.012 288.666L192.174 292.233C192.755 292.572 193.042 293.217 192.852 293.853L189.408 299.282C188.865 300.048 187.86 300.302 187.278 299.963Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_360",
    d: "M178.224 294.773L172.411 291.383C171.83 291.043 171.022 289.918 171.873 288.734L174.977 283.84C175.316 283.325 176.376 283.137 176.957 283.477L183.12 287.044C183.702 287.383 183.988 288.028 183.799 288.663L180.355 294.092C179.811 294.859 178.806 295.112 178.224 294.773Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_361",
    d: "M200.53 318.439L194.717 315.048C194.135 314.709 193.328 313.584 194.178 312.398L197.282 307.506C197.622 306.99 198.682 306.803 199.263 307.142L205.425 310.709C206.007 311.048 206.294 311.693 206.104 312.329L202.66 317.757C202.117 318.523 201.111 318.778 200.53 318.439Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_362",
    d: "M191.52 313.208L185.708 309.818C185.126 309.478 184.318 308.353 185.169 307.169L188.273 302.275C188.613 301.76 189.672 301.572 190.253 301.911L196.416 305.479C196.997 305.817 197.284 306.463 197.094 307.098L193.65 312.527C193.107 313.293 192.101 313.547 191.52 313.208Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_363",
    d: "M195.361 326.272L189.549 322.881C188.967 322.542 188.159 321.417 189.01 320.232L192.114 315.339C192.454 314.824 193.513 314.636 194.094 314.975L200.257 318.542C200.838 318.881 201.125 319.526 200.936 320.162L197.492 325.591C196.948 326.357 195.943 326.611 195.361 326.272Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_364",
    d: "M186.308 321.072L180.496 317.681C179.914 317.342 179.106 316.217 179.957 315.032L183.061 310.139C183.401 309.624 184.46 309.436 185.041 309.775L191.205 313.342C191.786 313.681 192.072 314.326 191.883 314.962L188.439 320.391C187.895 321.157 186.889 321.411 186.308 321.072Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_365",
    d: "M182.515 307.95L176.702 304.559C176.121 304.22 175.312 303.095 176.163 301.91L179.267 297.017C179.607 296.501 180.667 296.314 181.248 296.653L187.41 300.22C187.991 300.558 188.278 301.204 188.089 301.839L184.645 307.268C184.101 308.034 183.097 308.289 182.515 307.95Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_366",
    d: "M173.498 302.719L167.686 299.328C167.105 298.989 166.296 297.864 167.147 296.679L170.251 291.786C170.591 291.27 171.65 291.083 172.232 291.422L178.394 294.989C178.975 295.328 179.262 295.973 179.073 296.609L175.629 302.037C175.085 302.804 174.08 303.058 173.498 302.719Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_367",
    d: "M177.345 315.784L171.532 312.394C170.951 312.054 170.143 310.929 170.993 309.744L174.097 304.851C174.437 304.335 175.497 304.148 176.078 304.488L182.24 308.054C182.821 308.393 183.108 309.038 182.919 309.674L179.475 315.102C178.931 315.869 177.926 316.123 177.345 315.784Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_368",
    d: "M168.286 310.584L162.473 307.193C161.892 306.854 161.084 305.729 161.934 304.543L165.038 299.651C165.378 299.135 166.438 298.948 167.019 299.287L173.182 302.853C173.763 303.193 174.049 303.838 173.86 304.473L170.416 309.902C169.873 310.668 168.868 310.923 168.286 310.584Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_369",
    d: "M190.17 334.181L184.358 330.79C183.777 330.451 182.968 329.325 183.819 328.141L186.923 323.248C187.263 322.732 188.322 322.545 188.904 322.884L195.066 326.451C195.647 326.79 195.934 327.435 195.744 328.07L192.3 333.499C191.757 334.266 190.752 334.52 190.17 334.181Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_370",
    d: "M181.117 328.98L175.305 325.589C174.724 325.25 173.915 324.125 174.766 322.94L177.87 318.047C178.21 317.532 179.269 317.344 179.851 317.683L186.014 321.25C186.595 321.589 186.881 322.234 186.692 322.87L183.248 328.299C182.704 329.065 181.699 329.319 181.117 328.98Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_371",
    d: "M172.148 323.691L166.335 320.301C165.754 319.961 164.946 318.836 165.796 317.651L168.9 312.758C169.24 312.243 170.3 312.055 170.881 312.394L177.043 315.961C177.625 316.3 177.911 316.945 177.722 317.581L174.278 323.01C173.735 323.776 172.73 324.03 172.148 323.691Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_372",
    d: "M163.101 318.491L157.288 315.1C156.707 314.761 155.899 313.636 156.749 312.45L159.854 307.558C160.193 307.042 161.253 306.855 161.834 307.194L167.997 310.761C168.579 311.1 168.865 311.745 168.676 312.381L165.232 317.81C164.688 318.576 163.682 318.83 163.101 318.491Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_373",
    d: "M193.88 260.335L159.263 316.139L193.88 260.335Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_374",
    d: "M193.88 260.335L159.263 316.139L193.88 260.335Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_375",
    d: "M196.136 261.727L161.519 317.531L196.136 261.727Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_376",
    d: "M196.136 261.727L161.519 317.531L196.136 261.727Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_377",
    d: "M202.781 265.65L168.164 321.455L202.781 265.65Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_378",
    d: "M202.781 265.65L168.164 321.455L202.781 265.65Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_379",
    d: "M205.035 267.043L170.418 322.847L205.035 267.043Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_380",
    d: "M205.035 267.043L170.418 322.847L205.035 267.043Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_381",
    d: "M211.678 270.84L177.061 326.645L211.678 270.84Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_382",
    d: "M211.678 270.84L177.061 326.645L211.678 270.84Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_383",
    d: "M213.929 272.233L179.312 328.038L213.929 272.233Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_384",
    d: "M213.929 272.233L179.312 328.038L213.929 272.233Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_385",
    d: "M220.566 276.031L185.949 331.836L220.566 276.031Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_386",
    d: "M220.566 276.031L185.949 331.836L220.566 276.031Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_387",
    d: "M222.828 277.423L188.211 333.228L222.828 277.423Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_388",
    d: "M222.828 277.423L188.211 333.228L222.828 277.423Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_389",
    d: "M191.033 258.266L190.844 258.367L227.024 279.513L227.197 279.411L191.033 258.266Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_390",
    d: "M190.842 258.366L190.781 258.573L226.79 279.552L226.821 279.414L190.842 258.366Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_391",
    d: "M227.018 279.512L227.191 279.411L192.089 335.431L191.708 335.66L227.018 279.512Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_392",
    d: "M227.021 279.512L226.853 279.414L191.556 335.57L191.711 335.661L227.021 279.512Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_393",
    d: "M191.03 258.717L191.179 258.805L155.71 314.36L155.484 314.447L191.03 258.717Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_394",
    d: "M191.089 258.509L190.84 258.363L155.202 314.284L155.48 314.446L191.089 258.509Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_395",
    d: "M155.786 314.128L155.565 314.189L191.611 335.395L191.657 335.251L155.786 314.128Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_396",
    d: "M155.564 314.189L155.484 314.446L191.555 335.571L191.61 335.395L155.564 314.189Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_397",
    d: "M228.971 278.93L230.275 280.722L194.704 339.841L193.39 338.061L228.971 278.93Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_398",
    d: "M193.398 338.049L194.702 339.841L155.601 317.036L153.811 315.122L193.398 338.049Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_399",
    d: "M287.852 317.807C287.852 320.357 284.123 322.423 279.524 322.423C274.924 322.423 271.195 320.357 271.195 317.807C271.195 315.258 274.924 313.191 279.524 313.191C284.123 313.191 287.852 315.258 287.852 317.807Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_400",
    d: "M287.845 317.658C287.847 317.707 287.852 317.758 287.852 317.807C287.852 320.356 284.123 322.423 279.524 322.423C274.924 322.423 271.195 320.356 271.195 317.807V320.076H271.201C271.326 322.565 275.003 324.561 279.524 324.561C284.123 324.561 287.852 322.494 287.852 319.945V317.658H287.845Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_401",
    d: "M292.502 245.862L330.905 268.171L295.323 327.298L255.748 304.359L292.502 245.862Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_402",
    d: "M293.024 247.683L328.952 268.75L293.642 324.575L257.705 303.367L293.024 247.683Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_403",
    d: "M322.603 275.929L316.791 272.539C316.21 272.199 315.401 271.074 316.253 269.89L319.356 264.997C319.696 264.481 320.755 264.294 321.337 264.633L327.499 268.199C328.08 268.538 328.367 269.183 328.178 269.819L324.734 275.248C324.19 276.014 323.185 276.269 322.603 275.929Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_404",
    d: "M313.589 270.698L307.776 267.307C307.194 266.968 306.386 265.843 307.237 264.658L310.34 259.765C310.681 259.249 311.741 259.062 312.322 259.401L318.485 262.967C319.066 263.306 319.352 263.951 319.163 264.587L315.719 270.016C315.176 270.782 314.17 271.037 313.589 270.698Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_405",
    d: "M317.435 283.763L311.622 280.373C311.041 280.033 310.233 278.908 311.083 277.723L314.187 272.83C314.527 272.314 315.587 272.127 316.169 272.466L322.33 276.032C322.912 276.371 323.198 277.016 323.009 277.652L319.565 283.081C319.022 283.847 318.017 284.102 317.435 283.763Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_406",
    d: "M308.388 278.562L302.575 275.172C301.993 274.832 301.186 273.707 302.036 272.523L305.14 267.629C305.48 267.114 306.54 266.926 307.121 267.266L313.284 270.833C313.866 271.171 314.152 271.817 313.963 272.452L310.518 277.881C309.975 278.648 308.969 278.901 308.388 278.562Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_407",
    d: "M304.588 265.44L298.775 262.049C298.194 261.71 297.386 260.585 298.237 259.4L301.341 254.507C301.68 253.991 302.74 253.804 303.322 254.143L309.484 257.71C310.065 258.049 310.352 258.694 310.163 259.33L306.719 264.758C306.175 265.524 305.169 265.779 304.588 265.44Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_408",
    d: "M295.57 260.209L289.756 256.818C289.175 256.479 288.367 255.354 289.218 254.169L292.322 249.276C292.662 248.761 293.722 248.573 294.303 248.912L300.465 252.479C301.047 252.818 301.333 253.463 301.144 254.099L297.7 259.528C297.156 260.294 296.151 260.548 295.57 260.209Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_409",
    d: "M299.418 273.273L293.606 269.882C293.024 269.543 292.216 268.418 293.067 267.234L296.171 262.34C296.511 261.825 297.57 261.637 298.152 261.976L304.314 265.543C304.895 265.882 305.182 266.527 304.993 267.163L301.548 272.592C301.005 273.358 299.999 273.612 299.418 273.273Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_410",
    d: "M290.366 268.073L284.552 264.683C283.971 264.343 283.163 263.218 284.014 262.033L287.117 257.14C287.458 256.624 288.518 256.437 289.099 256.776L295.262 260.343C295.843 260.682 296.129 261.327 295.94 261.963L292.496 267.391C291.952 268.157 290.947 268.412 290.366 268.073Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_411",
    d: "M312.407 291.715L306.594 288.324C306.012 287.985 305.204 286.86 306.056 285.675L309.159 280.782C309.499 280.267 310.559 280.079 311.14 280.418L317.302 283.985C317.884 284.324 318.169 284.969 317.98 285.605L314.537 291.034C313.993 291.8 312.988 292.054 312.407 291.715Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_412",
    d: "M303.388 286.484L297.575 283.093C296.994 282.754 296.186 281.629 297.036 280.444L300.14 275.551C300.48 275.035 301.54 274.848 302.122 275.187L308.284 278.754C308.865 279.093 309.151 279.738 308.962 280.374L305.518 285.802C304.975 286.568 303.969 286.823 303.388 286.484Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_413",
    d: "M307.374 299.718L301.561 296.327C300.98 295.988 300.172 294.863 301.022 293.678L304.126 288.785C304.466 288.269 305.526 288.082 306.108 288.421L312.27 291.988C312.852 292.327 313.138 292.972 312.949 293.608L309.505 299.036C308.961 299.803 307.956 300.057 307.374 299.718Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_414",
    d: "M298.3 294.556L292.488 291.165C291.907 290.826 291.098 289.701 291.949 288.516L295.053 283.623C295.393 283.107 296.452 282.92 297.034 283.259L303.196 286.826C303.777 287.165 304.064 287.81 303.875 288.446L300.431 293.875C299.887 294.641 298.882 294.895 298.3 294.556Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_415",
    d: "M294.388 281.225L288.575 277.834C287.994 277.495 287.186 276.37 288.037 275.185L291.141 270.292C291.481 269.776 292.54 269.589 293.122 269.928L299.284 273.495C299.865 273.834 300.152 274.479 299.963 275.115L296.519 280.543C295.975 281.309 294.97 281.564 294.388 281.225Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_416",
    d: "M285.373 275.995L279.561 272.604C278.979 272.265 278.17 271.14 279.022 269.954L282.126 265.062C282.466 264.546 283.525 264.359 284.106 264.698L290.27 268.264C290.851 268.603 291.137 269.248 290.948 269.884L287.503 275.313C286.96 276.079 285.954 276.334 285.373 275.995Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_417",
    d: "M289.214 289.201L283.401 285.811C282.82 285.471 282.011 284.346 282.863 283.161L285.966 278.268C286.306 277.752 287.366 277.565 287.947 277.905L294.109 281.472C294.69 281.811 294.976 282.456 294.787 283.091L291.344 288.519C290.8 289.286 289.795 289.54 289.214 289.201Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_418",
    d: "M280.162 284.01L274.35 280.619C273.769 280.28 272.96 279.155 273.811 277.969L276.915 273.077C277.255 272.561 278.314 272.374 278.896 272.713L285.059 276.28C285.64 276.619 285.926 277.264 285.737 277.9L282.293 283.328C281.749 284.095 280.744 284.349 280.162 284.01Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_419",
    d: "M302.468 307.677L296.656 304.286C296.074 303.947 295.266 302.822 296.117 301.637L299.221 296.744C299.561 296.228 300.62 296.041 301.201 296.38L307.364 299.947C307.945 300.286 308.232 300.931 308.043 301.567L304.598 306.996C304.055 307.762 303.049 308.016 302.468 307.677Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_420",
    d: "M293.456 302.445L287.642 299.055C287.061 298.715 286.253 297.59 287.104 296.405L290.207 291.512C290.547 290.997 291.608 290.809 292.189 291.149L298.351 294.716C298.932 295.055 299.218 295.7 299.029 296.335L295.586 301.764C295.042 302.531 294.037 302.784 293.456 302.445Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_421",
    d: "M297.298 315.51L291.485 312.119C290.904 311.78 290.095 310.655 290.947 309.47L294.05 304.577C294.391 304.061 295.45 303.874 296.032 304.213L302.195 307.78C302.776 308.119 303.062 308.764 302.873 309.4L299.428 314.828C298.884 315.594 297.88 315.849 297.298 315.51Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_422",
    d: "M288.253 310.309L282.44 306.919C281.859 306.579 281.05 305.454 281.902 304.27L285.005 299.377C285.345 298.861 286.405 298.673 286.986 299.013L293.148 302.579C293.73 302.918 294.016 303.563 293.828 304.199L290.383 309.628C289.839 310.394 288.834 310.649 288.253 310.309Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_423",
    d: "M284.452 297.186L278.639 293.796C278.057 293.456 277.249 292.331 278.101 291.147L281.204 286.254C281.544 285.738 282.604 285.55 283.185 285.89L289.348 289.457C289.93 289.796 290.216 290.441 290.027 291.076L286.582 296.505C286.038 297.272 285.033 297.526 284.452 297.186Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_424",
    d: "M275.435 291.956L269.622 288.566C269.041 288.226 268.233 287.101 269.084 285.916L272.188 281.023C272.528 280.508 273.587 280.32 274.169 280.659L280.331 284.226C280.912 284.565 281.199 285.211 281.01 285.846L277.566 291.275C277.022 292.041 276.017 292.295 275.435 291.956Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_425",
    d: "M279.276 305.02L273.462 301.63C272.881 301.29 272.073 300.165 272.924 298.98L276.028 294.088C276.367 293.572 277.428 293.385 278.009 293.724L284.171 297.29C284.754 297.629 285.04 298.274 284.851 298.91L281.406 304.339C280.862 305.105 279.857 305.36 279.276 305.02Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_426",
    d: "M270.229 299.82L264.417 296.43C263.836 296.09 263.027 294.965 263.879 293.781L266.982 288.888C267.322 288.372 268.381 288.184 268.963 288.524L275.126 292.09C275.707 292.429 275.993 293.074 275.804 293.71L272.36 299.139C271.816 299.905 270.811 300.16 270.229 299.82Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_427",
    d: "M292.106 323.418L286.293 320.027C285.711 319.688 284.904 318.563 285.754 317.378L288.858 312.485C289.198 311.97 290.258 311.782 290.839 312.121L297.002 315.688C297.583 316.027 297.87 316.672 297.681 317.308L294.236 322.737C293.693 323.503 292.687 323.757 292.106 323.418Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_428",
    d: "M283.061 318.217L277.247 314.826C276.666 314.487 275.858 313.362 276.709 312.177L279.812 307.284C280.153 306.769 281.213 306.581 281.794 306.92L287.957 310.487C288.538 310.826 288.824 311.471 288.635 312.107L285.191 317.536C284.647 318.302 283.642 318.556 283.061 318.217Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_429",
    d: "M274.091 312.928L268.278 309.538C267.697 309.198 266.888 308.073 267.74 306.889L270.843 301.995C271.184 301.48 272.243 301.292 272.824 301.631L278.988 305.199C279.569 305.537 279.855 306.183 279.666 306.818L276.221 312.247C275.677 313.013 274.672 313.267 274.091 312.928Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_430",
    d: "M265.038 307.729L259.225 304.338C258.644 303.999 257.835 302.874 258.687 301.689L261.79 296.796C262.13 296.281 263.19 296.093 263.771 296.432L269.933 299.999C270.515 300.338 270.8 300.983 270.611 301.619L267.168 307.048C266.624 307.814 265.619 308.068 265.038 307.729Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_431",
    d: "M295.817 249.572L261.2 305.377L295.817 249.572Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_432",
    d: "M295.817 249.572L261.2 305.377L295.817 249.572Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_433",
    d: "M298.075 250.963L263.456 306.768L298.075 250.963Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_434",
    d: "M298.075 250.963L263.456 306.768L298.075 250.963Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_435",
    d: "M304.718 254.887L270.101 310.692L304.718 254.887Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_436",
    d: "M304.718 254.887L270.101 310.692L304.718 254.887Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_437",
    d: "M306.969 256.279L272.352 312.084L306.969 256.279Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_438",
    d: "M306.969 256.279L272.352 312.084L306.969 256.279Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_439",
    d: "M313.609 260.078L278.992 315.882L313.609 260.078Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_440",
    d: "M313.609 260.078L278.992 315.882L313.609 260.078Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_441",
    d: "M315.864 261.47L281.247 317.275L315.864 261.47Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_442",
    d: "M315.864 261.47L281.247 317.275L315.864 261.47Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_443",
    d: "M322.51 265.268L287.894 321.073L322.51 265.268Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_444",
    d: "M322.51 265.268L287.894 321.073L322.51 265.268Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_445",
    d: "M324.762 266.66L290.145 322.465L324.762 266.66Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_446",
    d: "M324.762 266.66L290.145 322.465L324.762 266.66Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_447",
    d: "M292.965 247.503L292.776 247.604L328.956 268.751L329.129 268.649L292.965 247.503Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_448",
    d: "M292.78 247.604L292.718 247.812L328.726 268.789L328.757 268.652L292.78 247.604Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_449",
    d: "M328.955 268.749L329.128 268.649L294.026 324.668L293.644 324.898L328.955 268.749Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_450",
    d: "M328.956 268.748L328.789 268.65L293.492 324.806L293.646 324.897L328.956 268.748Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_451",
    d: "M292.969 247.954L293.117 248.041L257.647 303.597L257.422 303.684L292.969 247.954Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_452",
    d: "M293.032 247.745L292.782 247.599L257.145 303.52L257.423 303.682L293.032 247.745Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_453",
    d: "M257.723 303.365L257.502 303.426L293.549 324.632L293.594 324.488L257.723 303.365Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_454",
    d: "M257.502 303.426L257.422 303.683L293.493 324.808L293.548 324.632L257.502 303.426Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_455",
    d: "M330.906 268.166L332.21 269.96L296.639 329.078L295.325 327.297L330.906 268.166Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_456",
    d: "M295.334 327.285L296.637 329.078L257.538 306.273L255.748 304.358L295.334 327.285Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_457",
    d: "M253.18 364.88L235.646 366.76L197.609 345.049L244.814 315.142L292.111 342.34L253.18 364.88Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_458",
    d: "M225.746 351.777C225.746 354.327 222.017 356.394 217.418 356.394C212.818 356.394 209.089 354.327 209.089 351.777C209.089 349.228 212.818 347.161 217.418 347.161C222.017 347.161 225.746 349.228 225.746 351.777Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_459",
    d: "M225.747 351.629C225.749 351.678 225.753 351.729 225.753 351.777C225.753 354.327 222.024 356.394 217.425 356.394C212.825 356.394 209.097 354.327 209.097 351.777V354.047H209.103C209.228 356.535 212.904 358.532 217.425 358.532C222.024 358.532 225.753 356.465 225.753 353.916V351.629H225.747Z",
    fill: "#E4EDEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_460",
    d: "M230.404 279.832L268.808 302.141L233.226 361.268L193.65 338.328L230.404 279.832Z",
    fill: "#D4E4E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_461",
    d: "M230.931 281.654L266.858 302.72L231.548 358.545L195.612 337.337L230.931 281.654Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_462",
    d: "M260.507 309.899L254.694 306.508C254.113 306.169 253.305 305.044 254.155 303.859L257.259 298.966C257.599 298.45 258.659 298.263 259.241 298.602L265.402 302.169C265.983 302.508 266.27 303.153 266.081 303.789L262.637 309.217C262.093 309.983 261.088 310.238 260.507 309.899Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_463",
    d: "M251.49 304.668L245.676 301.277C245.095 300.938 244.287 299.813 245.138 298.627L248.242 293.735C248.582 293.219 249.642 293.032 250.223 293.371L256.385 296.938C256.967 297.277 257.254 297.922 257.064 298.558L253.62 303.986C253.076 304.753 252.071 305.007 251.49 304.668Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_464",
    d: "M255.336 317.733L249.523 314.342C248.941 314.003 248.134 312.878 248.984 311.693L252.088 306.8C252.428 306.284 253.488 306.097 254.069 306.436L260.231 310.003C260.812 310.342 261.099 310.987 260.91 311.623L257.466 317.051C256.922 317.818 255.917 318.072 255.336 317.733Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_465",
    d: "M246.284 312.532L240.471 309.142C239.89 308.802 239.081 307.677 239.933 306.492L243.036 301.599C243.377 301.084 244.436 300.896 245.017 301.235L251.181 304.802C251.762 305.141 252.048 305.786 251.859 306.422L248.414 311.851C247.87 312.617 246.865 312.871 246.284 312.532Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_466",
    d: "M242.485 299.409L236.672 296.018C236.09 295.679 235.283 294.554 236.133 293.369L239.237 288.476C239.577 287.961 240.637 287.773 241.218 288.112L247.381 291.679C247.962 292.018 248.249 292.663 248.06 293.299L244.615 298.728C244.072 299.494 243.066 299.748 242.485 299.409Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_467",
    d: "M233.468 294.179L227.654 290.789C227.073 290.449 226.264 289.324 227.115 288.139L230.22 283.246C230.56 282.73 231.62 282.543 232.201 282.882L238.363 286.449C238.944 286.787 239.23 287.433 239.041 288.068L235.598 293.497C235.054 294.263 234.049 294.518 233.468 294.179Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_468",
    d: "M237.315 307.243L231.502 303.852C230.92 303.513 230.113 302.388 230.963 301.203L234.067 296.31C234.407 295.794 235.467 295.607 236.048 295.946L242.211 299.513C242.792 299.852 243.079 300.497 242.89 301.133L239.445 306.562C238.901 307.328 237.896 307.582 237.315 307.243Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_469",
    d: "M228.266 302.044L222.453 298.653C221.872 298.314 221.063 297.189 221.914 296.004L225.018 291.111C225.358 290.595 226.418 290.408 226.999 290.747L233.162 294.313C233.744 294.652 234.029 295.297 233.839 295.933L230.396 301.362C229.852 302.128 228.848 302.383 228.266 302.044Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_470",
    d: "M250.305 325.684L244.493 322.293C243.912 321.954 243.103 320.829 243.954 319.644L247.058 314.751C247.398 314.235 248.457 314.048 249.039 314.387L255.201 317.954C255.782 318.293 256.069 318.938 255.88 319.574L252.436 325.002C251.892 325.768 250.887 326.023 250.305 325.684Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_471",
    d: "M241.291 320.454L235.479 317.063C234.897 316.724 234.088 315.599 234.94 314.413L238.043 309.521C238.384 309.005 239.443 308.818 240.025 309.157L246.188 312.723C246.769 313.062 247.055 313.707 246.866 314.343L243.421 319.772C242.878 320.538 241.873 320.793 241.291 320.454Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_472",
    d: "M245.273 333.688L239.46 330.297C238.878 329.958 238.071 328.833 238.921 327.649L242.025 322.755C242.365 322.24 243.425 322.052 244.006 322.391L250.168 325.958C250.75 326.297 251.036 326.942 250.847 327.578L247.403 333.007C246.86 333.773 245.854 334.027 245.273 333.688Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_473",
    d: "M236.199 328.525L230.386 325.134C229.805 324.795 228.997 323.67 229.847 322.484L232.951 317.592C233.291 317.076 234.351 316.889 234.933 317.228L241.095 320.795C241.676 321.134 241.963 321.779 241.774 322.415L238.329 327.843C237.786 328.61 236.78 328.864 236.199 328.525Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_474",
    d: "M232.284 315.195L226.471 311.804C225.89 311.465 225.082 310.34 225.933 309.154L229.037 304.262C229.377 303.746 230.436 303.559 231.017 303.898L237.18 307.464C237.761 307.803 238.048 308.448 237.859 309.084L234.415 314.513C233.871 315.279 232.866 315.534 232.284 315.195Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_475",
    d: "M223.264 309.964L217.451 306.574C216.869 306.234 216.061 305.109 216.912 303.924L220.016 299.031C220.356 298.515 221.416 298.328 221.997 298.667L228.16 302.235C228.742 302.574 229.028 303.219 228.838 303.854L225.394 309.282C224.851 310.049 223.845 310.303 223.264 309.964Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_476",
    d: "M227.114 323.17L221.302 319.78C220.72 319.44 219.912 318.315 220.763 317.13L223.867 312.237C224.207 311.722 225.266 311.534 225.847 311.873L232.011 315.44C232.592 315.779 232.878 316.424 232.688 317.06L229.244 322.489C228.701 323.255 227.695 323.509 227.114 323.17Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_477",
    d: "M218.061 317.979L212.249 314.589C211.668 314.249 210.859 313.124 211.71 311.94L214.814 307.047C215.154 306.531 216.213 306.344 216.794 306.683L222.958 310.25C223.539 310.589 223.825 311.234 223.636 311.869L220.192 317.298C219.648 318.065 218.643 318.319 218.061 317.979Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_478",
    d: "M240.371 341.646L234.558 338.255C233.977 337.916 233.168 336.791 234.02 335.606L237.123 330.713C237.464 330.198 238.523 330.01 239.104 330.349L245.268 333.916C245.849 334.255 246.135 334.9 245.946 335.536L242.501 340.965C241.957 341.731 240.952 341.985 240.371 341.646Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_479",
    d: "M231.354 336.416L225.541 333.026C224.96 332.686 224.151 331.561 225.002 330.376L228.106 325.483C228.446 324.967 229.506 324.78 230.088 325.119L236.249 328.686C236.83 329.025 237.117 329.671 236.928 330.306L233.484 335.734C232.94 336.5 231.936 336.755 231.354 336.416Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_480",
    d: "M235.201 349.48L229.389 346.089C228.807 345.75 227.998 344.625 228.85 343.44L231.953 338.547C232.293 338.032 233.353 337.844 233.934 338.183L240.097 341.75C240.679 342.089 240.965 342.734 240.776 343.37L237.331 348.799C236.787 349.565 235.782 349.819 235.201 349.48Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_481",
    d: "M226.15 344.279L220.337 340.888C219.756 340.549 218.948 339.424 219.798 338.239L222.902 333.346C223.242 332.831 224.302 332.643 224.883 332.982L231.046 336.549C231.627 336.888 231.913 337.533 231.724 338.169L228.28 343.598C227.737 344.364 226.731 344.618 226.15 344.279Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_482",
    d: "M222.348 331.157L216.535 327.767C215.954 327.427 215.146 326.302 215.997 325.117L219.101 320.224C219.441 319.708 220.5 319.521 221.081 319.86L227.244 323.427C227.825 323.766 228.112 324.411 227.923 325.046L224.479 330.475C223.935 331.241 222.93 331.496 222.348 331.157Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_483",
    d: "M213.329 325.926L207.517 322.535C206.936 322.196 206.127 321.071 206.978 319.886L210.082 314.993C210.422 314.478 211.481 314.29 212.063 314.629L218.225 318.196C218.806 318.535 219.093 319.18 218.904 319.816L215.46 325.245C214.916 326.011 213.911 326.265 213.329 325.926Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_484",
    d: "M217.178 338.991L211.365 335.601C210.784 335.261 209.976 334.136 210.827 332.951L213.931 328.058C214.27 327.542 215.33 327.355 215.911 327.695L222.074 331.261C222.655 331.6 222.942 332.245 222.753 332.88L219.309 338.309C218.765 339.076 217.759 339.33 217.178 338.991Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_485",
    d: "M208.125 333.791L202.313 330.4C201.732 330.061 200.923 328.936 201.774 327.75L204.878 322.858C205.218 322.342 206.277 322.155 206.858 322.494L213.022 326.061C213.603 326.4 213.889 327.045 213.7 327.681L210.256 333.109C209.712 333.875 208.707 334.13 208.125 333.791Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_486",
    d: "M230.009 357.388L224.196 353.998C223.615 353.658 222.807 352.533 223.657 351.348L226.761 346.455C227.101 345.939 228.161 345.752 228.742 346.092L234.904 349.658C235.486 349.997 235.772 350.642 235.583 351.278L232.139 356.706C231.596 357.473 230.59 357.727 230.009 357.388Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_487",
    d: "M220.959 352.188L215.146 348.797C214.565 348.458 213.757 347.333 214.608 346.148L217.712 341.255C218.051 340.74 219.111 340.552 219.692 340.891L225.855 344.458C226.437 344.797 226.723 345.442 226.534 346.078L223.09 351.507C222.546 352.273 221.541 352.527 220.959 352.188Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_488",
    d: "M211.987 346.898L206.175 343.508C205.593 343.168 204.785 342.043 205.636 340.858L208.74 335.965C209.08 335.449 210.139 335.262 210.72 335.601L216.883 339.168C217.464 339.507 217.751 340.152 217.562 340.788L214.118 346.216C213.574 346.983 212.569 347.237 211.987 346.898Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_489",
    d: "M202.936 341.698L197.123 338.307C196.542 337.968 195.734 336.843 196.585 335.658L199.689 330.765C200.029 330.25 201.088 330.062 201.669 330.401L207.833 333.968C208.414 334.307 208.7 334.952 208.511 335.588L205.067 341.017C204.523 341.783 203.517 342.037 202.936 341.698Z",
    fill: "#59277F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_490",
    d: "M233.719 283.542L199.102 339.346L233.719 283.542Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_491",
    d: "M233.719 283.542L199.102 339.346L233.719 283.542Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_492",
    d: "M235.973 284.934L201.356 340.738L235.973 284.934Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_493",
    d: "M235.973 284.934L201.356 340.738L235.973 284.934Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_494",
    d: "M242.617 288.857L208 344.662L242.617 288.857Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_495",
    d: "M242.617 288.857L208 344.662L242.617 288.857Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_496",
    d: "M244.87 290.249L210.253 346.054L244.87 290.249Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_497",
    d: "M244.87 290.249L210.253 346.054L244.87 290.249Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_498",
    d: "M251.513 294.048L216.896 349.852L251.513 294.048Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_499",
    d: "M251.513 294.048L216.896 349.852L251.513 294.048Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_500",
    d: "M253.766 295.44L219.149 351.244L253.766 295.44Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_501",
    d: "M253.766 295.44L219.149 351.244L253.766 295.44Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_502",
    d: "M260.401 299.239L225.784 355.043L260.401 299.239Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_503",
    d: "M260.401 299.239L225.784 355.043L260.401 299.239Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_504",
    d: "M262.667 300.631L228.05 356.435L262.667 300.631Z",
    fill: "#8D9277"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_505",
    d: "M262.667 300.631L228.05 356.435L262.667 300.631Z",
    stroke: "#FEFEFF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_506",
    d: "M230.866 281.473L230.677 281.574L266.858 302.72L267.03 302.618L230.866 281.473Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_507",
    d: "M230.676 281.573L230.615 281.78L266.624 302.759L266.655 302.621L230.676 281.573Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_508",
    d: "M266.858 302.719L267.031 302.619L231.928 358.638L231.547 358.867L266.858 302.719Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_509",
    d: "M266.858 302.719L266.691 302.622L231.394 358.778L231.548 358.869L266.858 302.719Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_510",
    d: "M230.864 281.923L231.013 282.011L195.544 337.567L195.318 337.653L230.864 281.923Z",
    fill: "#D5D5CC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_511",
    d: "M230.929 281.716L230.679 281.57L195.042 337.491L195.319 337.653L230.929 281.716Z",
    fill: "#F0F0EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_512",
    d: "M195.619 337.335L195.398 337.396L231.445 358.602L231.49 358.458L195.619 337.335Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_513",
    d: "M195.398 337.396L195.318 337.653L231.391 358.778L231.444 358.602L195.398 337.396Z",
    fill: "#E5E4DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_514",
    d: "M268.806 302.137L270.109 303.929L234.539 363.049L233.225 361.268L268.806 302.137Z",
    fill: "#8D8A83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_515",
    d: "M233.236 361.257L234.539 363.049L195.44 340.244L193.65 338.329L233.236 361.257Z",
    fill: "#F8F8F9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99",
    cx: 134.507,
    cy: 286.327,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98",
    cx: 134.507,
    cy: 286.327,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M134.497 278.315L135.12 284.7H133.894L134.497 278.315Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2",
    d: "M134.497 294.277L135.12 287.892H133.894L134.497 294.277Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M126.668 286.317L133.053 286.939L133.053 285.714L126.668 286.317Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4",
    d: "M142.47 286.317L136.085 286.939L136.085 285.714L142.47 286.317Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_2",
    cx: 252.221,
    cy: 253.203,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_2",
    cx: 252.221,
    cy: 253.203,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_2",
    d: "M252.211 245.191L252.834 251.577H251.608L252.211 245.191Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_2",
    d: "M252.211 261.154L252.834 254.769H251.608L252.211 261.154Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_2",
    d: "M244.382 253.194L250.767 253.816L250.767 252.591L244.382 253.194Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_2",
    d: "M260.184 253.194L253.799 253.816L253.799 252.591L260.184 253.194Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_3",
    cx: 164.589,
    cy: 221.052,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_3",
    cx: 164.589,
    cy: 221.052,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_3",
    d: "M164.58 213.04L165.202 219.426H163.976L164.58 213.04Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_3",
    d: "M164.58 229.003L165.202 222.618H163.976L164.58 229.003Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_3",
    d: "M156.75 221.043L163.135 221.665L163.135 220.44L156.75 221.043Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_3",
    d: "M172.552 221.043L166.167 221.665L166.167 220.44L172.552 221.043Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_4",
    cx: 232.451,
    cy: 302.513,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_4",
    cx: 232.451,
    cy: 302.513,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_4",
    d: "M232.442 294.502L233.064 300.887H231.839L232.442 294.502Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_4",
    d: "M232.442 310.464L233.064 304.079H231.839L232.442 310.464Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_4",
    d: "M224.613 302.504L230.998 303.126L230.998 301.901L224.613 302.504Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_4",
    d: "M240.415 302.504L234.03 303.126L234.03 301.901L240.415 302.504Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare5"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_5",
    cx: 115.873,
    cy: 242.073,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_5",
    cx: 115.873,
    cy: 242.073,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_5",
    d: "M115.863 234.061L116.485 240.446H115.26L115.863 234.061Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_5",
    d: "M115.863 250.023L116.485 243.638H115.26L115.863 250.023Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_5",
    d: "M108.034 242.063L114.419 242.686L114.419 241.46L108.034 242.063Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_5",
    d: "M123.836 242.063L117.451 242.686L117.451 241.46L123.836 242.063Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare6"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_6",
    cx: 290.49,
    cy: 292.34,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_6",
    cx: 290.49,
    cy: 292.34,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_6",
    d: "M290.481 284.328L291.103 290.713H289.878L290.481 284.328Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_6",
    d: "M290.481 300.29L291.103 293.905H289.878L290.481 300.29Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_6",
    d: "M282.651 292.33L289.037 292.952L289.037 291.727L282.651 292.33Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_6",
    d: "M298.454 292.33L292.069 292.952L292.069 291.727L298.454 292.33Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare7"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_7",
    cx: 161.292,
    cy: 254.25,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_7",
    cx: 161.292,
    cy: 254.25,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_7",
    d: "M161.282 246.238L161.904 252.623H160.679L161.282 246.238Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_7",
    d: "M161.282 262.2L161.904 255.815H160.679L161.282 262.2Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_7",
    d: "M153.453 254.24L159.838 254.863L159.838 253.637L153.453 254.24Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_7",
    d: "M169.255 254.24L162.87 254.863L162.87 253.637L169.255 254.24Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare8"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_8",
    cx: 194.307,
    cy: 211.99,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_8",
    cx: 194.307,
    cy: 211.99,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_8",
    d: "M194.297 203.978L194.92 210.363H193.694L194.297 203.978Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_8",
    d: "M194.297 219.94L194.92 213.555H193.694L194.297 219.94Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_8",
    d: "M186.468 211.98L192.853 212.603L192.853 211.377L186.468 211.98Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_8",
    d: "M202.27 211.98L195.885 212.603L195.885 211.377L202.27 211.98Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_9",
    cx: 223.049,
    cy: 242.021,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_9",
    cx: 223.049,
    cy: 242.021,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_9",
    d: "M223.04 234.009L223.662 240.394H222.437L223.04 234.009Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_9",
    d: "M223.04 249.971L223.662 243.586H222.437L223.04 249.971Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_9",
    d: "M215.211 242.011L221.596 242.634L221.596 241.408L215.211 242.011Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_9",
    d: "M231.013 242.011L224.628 242.634L224.628 241.408L231.013 242.011Z",
    fill: "white",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "lens-flare10"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 99_10",
    cx: 198.778,
    cy: 289.043,
    r: 2.71999,
    fill: "white",
    fillOpacity: 0.73
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 98_10",
    cx: 198.778,
    cy: 289.043,
    r: 1.75829,
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1_10",
    d: "M198.769 281.031L199.391 287.416H198.166L198.769 281.031Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 2_10",
    d: "M198.769 296.994L199.391 290.608H198.166L198.769 296.994Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3_10",
    d: "M190.94 289.034L197.325 289.656L197.325 288.431L190.94 289.034Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 4_10",
    d: "M206.742 289.034L200.357 289.656L200.357 288.431L206.742 289.034Z",
    fill: "white",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Baum_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_516",
    d: "M386.625 267.985C371.882 267.985 359.931 273.492 359.931 280.287C359.931 287.082 371.882 292.59 386.625 292.59C401.368 292.59 413.319 287.082 413.319 280.287C413.319 273.492 401.368 267.985 386.625 267.985Z",
    fill: "#5B703A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_517",
    d: "M366.865 283.696L369.625 262.073C369.613 262.526 369.743 262.971 369.997 263.346C370.251 263.721 370.616 264.007 371.041 264.164C372.092 264.69 373.249 264.97 374.425 264.983C375.6 264.996 376.764 264.741 377.826 264.238C378.226 264.067 378.57 263.788 378.82 263.433C379.07 263.077 379.217 262.659 379.243 262.225L382.225 284.524C382.374 285.791 381.628 287.059 379.988 288.028C378.277 288.891 376.388 289.341 374.472 289.341C372.555 289.341 370.666 288.891 368.955 288.028C366.866 286.902 366.195 285.184 366.865 283.696Z",
    fill: "#816955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_518",
    d: "M392.291 223.45C381.543 223.45 372.831 232.53 372.831 243.731C372.831 254.932 381.543 264.011 392.291 264.011C403.039 264.011 411.751 254.932 411.751 243.731C411.751 232.53 403.039 223.45 392.291 223.45Z",
    fill: "#558835"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_519",
    d: "M364.555 219.871C355.002 219.871 347.257 227.949 347.257 237.914C347.257 247.88 355.002 255.958 364.555 255.958C374.108 255.958 381.853 247.88 381.853 237.914C381.853 227.949 374.108 219.871 364.555 219.871Z",
    fill: "#619640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_520",
    d: "M352.251 245.519C359.036 249.396 369.997 249.396 376.782 245.519C380.213 243.506 381.927 240.897 381.853 238.287C382.3 241.121 380.66 244.849 376.858 247.086C370.074 250.963 359.113 250.963 352.328 247.086C350.929 246.306 349.737 245.201 348.855 243.864C347.972 242.528 347.424 240.998 347.257 239.405C347.629 241.643 349.268 243.805 352.251 245.519Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_521",
    d: "M379.317 236.573C370.711 236.573 363.734 243.817 363.734 252.753C363.734 261.688 370.711 268.931 379.317 268.931C387.924 268.931 394.901 261.688 394.901 252.753C394.901 243.817 387.924 236.573 379.317 236.573Z",
    fill: "#65A246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_522",
    d: "M368.209 259.612C374.322 263.116 384.165 263.116 390.275 259.612C393.411 257.822 394.898 255.431 394.823 253.125C395.196 255.661 393.704 259.016 390.35 261.029C384.236 264.533 374.393 264.533 368.283 261.029C367.017 260.332 365.94 259.335 365.148 258.126C364.355 256.917 363.87 255.533 363.735 254.094C364.032 256.108 365.528 258.047 368.209 259.612Z",
    fill: "#D9D9D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_523",
    d: "M369.774 249.696C372.73 251.203 376 251.988 379.318 251.988C382.635 251.988 385.906 251.203 388.861 249.696C389.848 249.227 390.716 248.54 391.4 247.688C392.084 246.836 392.566 245.839 392.81 244.774C393.109 246.937 391.765 249.174 388.861 250.888C385.906 252.395 382.635 253.181 379.318 253.181C376 253.181 372.73 252.395 369.774 250.888C366.871 249.248 365.594 247.011 365.826 244.774C366.047 246.564 367.387 248.278 369.774 249.696Z",
    fill: "#D9D9D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErzeugungsanlagenBusiness);
export default __webpack_public_path__ + "static/media/ErzeugungsanlagenBusiness.2633f4ccae5a65340ad3a629054d0f2e.svg";
export { ForwardRef as ReactComponent };